<div class="event-settings" *ngIf="isMobile">

  <div class="page-header" *ngIf="!showFullPage">
    <div class="header-bar">
      <button (click)="goBack()" class="back-btn">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="40" height="40" rx="20" fill="white" />
          <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
          <path d="M28 20H12M12 20L18 14M12 20L18 26" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <span>Event Settings</span>
      <img [src]="eventData?.hostImage" class="profile-pic" alt="Profile"
        *ngIf="eventData?.hostImage; else initialHost"
        onerror="this.onerror=null;this.src='/assets/icon/imageplaceholder.png'" />
      <ng-template #initialHost>
        <div class="collab-avatar fallback" style="padding-left: 0px;">
          {{ eventData?.hostName ? eventData?.hostName.charAt(0).toUpperCase() :
          eventData?.hostedBy?.charAt(0)?.toUpperCase() }}
        </div>
      </ng-template>
    </div>


  </div>
  <section class="event-info" *ngIf="!showFullPage">

    <div class="menu-card">
      <div class="menu-item">
        <div class="profile-section">
          <img *ngIf="eventData?.coverImage" [src]="eventData?.coverImage" alt="Main Profile" class="main-avatar"
            onerror="this.onerror=null;this.src='/assets/images/default_cover.png'" />
          <img *ngIf="!eventData?.coverImage" src="/assets/images/default_cover.png" alt="Main Profile"
            class="main-avatar" />

          <div class="profile-info-text">
            <div class="profile-name text-overflow">{{ eventData?.eventName }}</div>
            <div class="profile-role">{{ inviteData?.host_name }}</div>
            <div class="event-meta-chips">
              <span class="meta-chip" *ngIf="eventImageCount > 0">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                  style="vertical-align:middle;margin-right:3px">
                  <path
                    d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM5 15L8.5 10.5L11 13.5L14.5 9L19 15H5Z"
                    fill="currentColor" />
                </svg>
                {{ eventImageCount }} photos
              </span>
              <span class="meta-chip" *ngIf="eventVideoCount > 0">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                  style="vertical-align:middle;margin-right:3px">
                  <path
                    d="M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5Z"
                    fill="currentColor" />
                </svg>
                {{ eventVideoCount }} videos
              </span>
              <span class="meta-chip" *ngIf="eventStorageBytes > 0">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                  style="vertical-align:middle;margin-right:3px">
                  <path d="M2 20H22V4H2V20ZM4 6H20V14H4V6ZM6 8V12H18V8H6Z" fill="currentColor" />
                </svg>
                {{ eventStorage }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="menu-item" (click)="goTo('edit-event')">
        <span>Event Details</span>
        <span class="icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
      </div>
      <div class="menu-item" *ngIf="isHost == false || isHost == 'false'" (click)="exitEvent()">
        <span>Exit Event</span>
      </div>
      <div class="menu-item" *ngIf="isHost == true || isHost == 'true'" (click)="showDefaultTabOptions()">
        <span>Landing Page</span>
        <span class="icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
      </div>
      <div class="menu-item" *ngIf="isHost == true || isHost == 'true'" (click)="showBulkDownloadOptions()">
        <span>Bulk Download</span>
        <span class="icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
      </div>
      <div class="menu-item" *ngIf="env.features.manageEventHub && (isHost == true || isHost == 'true')" (click)="showSortOrderOptions()">
        <span>Sorting Order</span>
        <span class="icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
      </div>
      <div class="menu-item" *ngIf="env.features.manageEventHub && (isHost == true || isHost == 'true')" (click)="showGuestUploadsOptions()">
        <span>Guest Uploads</span>
        <span class="icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
      </div>
      <div class="menu-item" *ngIf="(isHost == true || isHost == 'true') && canUseBranding && env.features.eventBranding" (click)="showBranding()">
        <span>Branding</span>
        <span class="icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
      </div>
      <div class="menu-item" *ngIf="isHost == true || isHost == 'true'" (click)="showTemplates()">
        <span>Templates</span>
        <span class="icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
      </div>
      <div class="menu-item" *ngIf="isHost == true || isHost == 'true'" (click)="confirmDelete()">
        <span>Delete Event</span>
      </div>
      <!-- <div class="menu-item" (click)="goTo('edit-event-info')">
        <span>Event Configuration</span>
        <span class="icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
      </div> -->

    </div>

  </section>

  <!-- Mobile View for Landing Page -->
  <section *ngIf="isMobile && currentSection === 3 && showFullPage" class="mobile-section-fullpage">
    <div class="page-header-fullpage">
      <div class="header-bar">
        <button (click)="showFullPage = false; currentSection = 0" class="back-btn">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="20" fill="white" />
            <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
            <path d="M28 20H12M12 20L18 14M12 20L18 26" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <span>Landing Page Settings</span>
        <div style="width: 40px;"></div>
      </div>
    </div>
    <div class="section-content-fullpage">
      <div class="header-2" style="float: left;">Change Landing Page</div>
      <div>
        <button *ngIf="!isEditable && (isHost === true || isHost === 'true')" (click)="toggleEdit()" type="button"
          class="picaggo-btn-primary" style="float: right;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M3.25 22C3.25 21.5858 3.58579 21.25 4 21.25H20C20.4142 21.25 20.75 21.5858 20.75 22C20.75 22.4142 20.4142 22.75 20 22.75H4C3.58579 22.75 3.25 22.4142 3.25 22Z"
              fill="white" />
            <path
              d="M11.5201 14.929L11.5201 14.9289L17.4368 9.01225C16.6315 8.6771 15.6777 8.12656 14.7757 7.22455C13.8736 6.32238 13.323 5.36846 12.9879 4.56312L7.07106 10.4799L7.07101 10.48C6.60932 10.9417 6.37846 11.1725 6.17992 11.4271C5.94571 11.7273 5.74491 12.0522 5.58107 12.396C5.44219 12.6874 5.33894 12.9972 5.13245 13.6167L4.04356 16.8833C3.94194 17.1882 4.02128 17.5243 4.2485 17.7515C4.47573 17.9787 4.81182 18.0581 5.11667 17.9564L8.38334 16.8676C9.00281 16.6611 9.31256 16.5578 9.60398 16.4189C9.94775 16.2551 10.2727 16.0543 10.5729 15.8201C10.8275 15.6215 11.0584 15.3907 11.5201 14.929Z"
              fill="white" />
            <path
              d="M19.0786 7.37044C20.3071 6.14188 20.3071 4.14999 19.0786 2.92142C17.85 1.69286 15.8581 1.69286 14.6296 2.92142L13.9199 3.63105C13.9296 3.6604 13.9397 3.69015 13.9502 3.72028C14.2103 4.47 14.701 5.45281 15.6243 6.37602C16.5475 7.29923 17.5303 7.78999 18.28 8.05009C18.31 8.0605 18.3396 8.07054 18.3688 8.08021L19.0786 7.37044Z"
              fill="white" />
          </svg>
          Edit
        </button>
      </div>
      <div style="clear: both;"></div>
      <div class="event-content-mobile">
        <form [formGroup]="newEventForm">
          <div class="form-group">
            <div class="radio-group">
              <label class="radio-option" [class.disabled]="!isEditable">
                <input type="radio" formControlName="defaultTab" value="photos" [disabled]="!isEditable">
                <span class="radio-label">
                  <!-- <span class="radio-icon">📷</span> -->
                  <span class="radio-text">Photos</span>
                </span>
              </label>
              <label class="radio-option" [class.disabled]="!isEditable">
                <input type="radio" formControlName="defaultTab" value="guestbook" [disabled]="!isEditable">
                <span class="radio-label">
                  <!-- <span class="radio-icon">📝</span> -->
                  <span class="radio-text">Guestbook</span>
                </span>
              </label>
            </div>
            <small class="hint">Select which tab guests will see first when they open the event</small>
          </div>
          <div class="action-buttons" *ngIf="isEditable">
            <button type="button" class="btn-cancel" (click)="cancelEdit()" [disabled]="isLoading">
              Cancel
            </button>
            <button type="button" class="btn-save picaggo-btn-primary" (click)="saveDefaultTab()"
              [disabled]="isLoading">
              <span>
                Save Changes
              </span>
              <!-- <span *ngIf="isLoading" class="loader-small"></span> -->
            </button>
          </div>
        </form>
      </div>
    </div>
  </section>

  <!-- Mobile View for Bulk Download Permission -->
  <section *ngIf="isMobile && currentSection === 4 && showFullPage" class="mobile-section-fullpage">
    <div class="page-header-fullpage">
      <div class="header-bar">
        <button (click)="showFullPage = false; currentSection = 0" class="back-btn">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="20" fill="white" />
            <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
            <path d="M28 20H12M12 20L18 14M12 20L18 26" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <span>Bulk Download Settings</span>
        <div style="width: 40px;"></div>
      </div>
    </div>
    <div class="section-content-fullpage">
      <div class="header-2" style="float: left;">Bulk Download</div>
      <div>
        <button *ngIf="!isEditable && (isHost === true || isHost === 'true')" (click)="toggleEdit()" type="button"
          class="picaggo-btn-primary" style="float: right;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M3.25 22C3.25 21.5858 3.58579 21.25 4 21.25H20C20.4142 21.25 20.75 21.5858 20.75 22C20.75 22.4142 20.4142 22.75 20 22.75H4C3.58579 22.75 3.25 22.4142 3.25 22Z"
              fill="white" />
            <path
              d="M11.5201 14.929L11.5201 14.9289L17.4368 9.01225C16.6315 8.6771 15.6777 8.12656 14.7757 7.22455C13.8736 6.32238 13.323 5.36846 12.9879 4.56312L7.07106 10.4799L7.07101 10.48C6.60932 10.9417 6.37846 11.1725 6.17992 11.4271C5.94571 11.7273 5.74491 12.0522 5.58107 12.396C5.44219 12.6874 5.33894 12.9972 5.13245 13.6167L4.04356 16.8833C3.94194 17.1882 4.02128 17.5243 4.2485 17.7515C4.47573 17.9787 4.81182 18.0581 5.11667 17.9564L8.38334 16.8676C9.00281 16.6611 9.31256 16.5578 9.60398 16.4189C9.94775 16.2551 10.2727 16.0543 10.5729 15.8201C10.8275 15.6215 11.0584 15.3907 11.5201 14.929Z"
              fill="white" />
            <path
              d="M19.0786 7.37044C20.3071 6.14188 20.3071 4.14999 19.0786 2.92142C17.85 1.69286 15.8581 1.69286 14.6296 2.92142L13.9199 3.63105C13.9296 3.6604 13.9397 3.69015 13.9502 3.72028C14.2103 4.47 14.701 5.45281 15.6243 6.37602C16.5475 7.29923 17.5303 7.78999 18.28 8.05009C18.31 8.0605 18.3396 8.07054 18.3688 8.08021L19.0786 7.37044Z"
              fill="white" />
          </svg>
          Edit
        </button>
      </div>
      <div style="clear: both;"></div>
      <div class="event-content-mobile">
        <form [formGroup]="newEventForm">
          <div class="form-group">
            <div class="radio-group">
              <label class="radio-option" [class.disabled]="!isEditable">
                <input type="radio" formControlName="allowBulkDownload" [value]="false" [disabled]="!isEditable">
                <span class="radio-label">
                  <span class="radio-text">Allow participants to bulk download</span>
                </span>
              </label>
              <label class="radio-option" [class.disabled]="!isEditable">
                <input type="radio" formControlName="allowBulkDownload" [value]="true" [disabled]="!isEditable">
                <span class="radio-label">
                  <span class="radio-text">Only host can bulk download</span>
                </span>
              </label>
            </div>
            <small class="hint">Control whether event participants can download all photos at once</small>
          </div>
          <div class="action-buttons" *ngIf="isEditable">
            <button type="button" class="btn-cancel" (click)="cancelEdit()" [disabled]="isLoading">
              Cancel
            </button>
            <button type="button" class="btn-save picaggo-btn-primary" (click)="saveBulkDownloadSetting()"
              [disabled]="isLoading">
              <span>
                Save Changes
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </section>

  <!-- Mobile View for Sorting Order -->
  <section *ngIf="isMobile && currentSection === 7 && showFullPage" class="mobile-section-fullpage">
    <div class="page-header-fullpage">
      <div class="header-bar">
        <button (click)="showFullPage = false; currentSection = 0" class="back-btn">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="20" fill="white" />
            <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
            <path d="M28 20H12M12 20L18 14M12 20L18 26" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <span>Sorting Order</span>
        <div style="width: 40px;"></div>
      </div>
    </div>
    <div class="section-content-fullpage">
      <div class="header-2" style="float: left;">Photo Sorting Order</div>
      <div>
        <button *ngIf="!isEditable && (isHost === true || isHost === 'true')" (click)="toggleEdit()" type="button"
          class="picaggo-btn-primary" style="float: right;">
          Edit
        </button>
      </div>
      <div style="clear: both;"></div>
      <div class="event-content-mobile">
        <form [formGroup]="newEventForm">
          <div class="form-group">
            <div class="radio-group">
              <label class="radio-option" [class.disabled]="!isEditable">
                <input type="radio" formControlName="sortOrder" value="desc" [disabled]="!isEditable">
                <span class="radio-label">
                  <span class="radio-text">Latest First</span>
                </span>
              </label>
              <label class="radio-option" [class.disabled]="!isEditable">
                <input type="radio" formControlName="sortOrder" value="asc" [disabled]="!isEditable">
                <span class="radio-label">
                  <span class="radio-text">Oldest First</span>
                </span>
              </label>
            </div>
            <small class="hint">Choose the default order photos appear in for everyone viewing the gallery</small>
          </div>
          <div class="action-buttons" *ngIf="isEditable">
            <button type="button" class="btn-cancel" (click)="cancelEdit()" [disabled]="isLoading">
              Cancel
            </button>
            <button type="button" class="btn-save picaggo-btn-primary" (click)="saveSortOrder()"
              [disabled]="isLoading">
              <span>
                Save Changes
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </section>

  <!-- Mobile View for Guest Uploads -->
  <section *ngIf="isMobile && currentSection === 8 && showFullPage" class="mobile-section-fullpage">
    <div class="page-header-fullpage">
      <div class="header-bar">
        <button (click)="showFullPage = false; currentSection = 0" class="back-btn">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="20" fill="white" />
            <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
            <path d="M28 20H12M12 20L18 14M12 20L18 26" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <span>Guest Uploads</span>
        <div style="width: 40px;"></div>
      </div>
    </div>
    <div class="section-content-fullpage">
      <div class="header-2" style="float: left;">Allow Guest Uploads</div>
      <div style="clear: both;"></div>
      <div class="event-content-mobile">
        <div class="form-group">
          <div style="display:flex; align-items:center; justify-content:space-between;">
            <span class="radio-text">{{ allowGuestUploads ? 'Guests can view & upload' : 'Guests can only view' }}</span>
            <label class="switch">
              <input type="checkbox" [(ngModel)]="allowGuestUploads" [ngModelOptions]="{ standalone: true }">
              <span class="slider round"></span>
            </label>
          </div>
          <small class="hint">{{ guestUploadsHint }}</small>
        </div>
        <div class="form-group" *ngIf="guestUploadsQrImage">
          <img [src]="guestUploadsQrImage" alt="Guest access QR Code" style="max-width: 200px; display: block; margin: 0 auto;" />
        </div>
        <div class="form-group" *ngIf="guestUploadsLink" style="display:flex; align-items:center; gap:8px;">
          <span style="flex:1; word-break: break-all; font-size: 13px;">{{ guestUploadsLink }}</span>
          <button type="button" class="btn-cancel" (click)="copyGuestUploadsLink()">{{ guestUploadsLinkCopied ? 'Copied!' : 'Copy' }}</button>
        </div>
      </div>
    </div>
  </section>

  <!-- Mobile View for Canva Templates -->
  <section *ngIf="isMobile && currentSection === 6 && showFullPage" class="mobile-section-fullpage">
    <div class="page-header-fullpage">
      <div class="header-bar">
        <button (click)="showFullPage = false; currentSection = 0" class="back-btn">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="20" fill="white" />
            <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
            <path d="M28 20H12M12 20L18 14M12 20L18 26" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <span>Templates</span>
        <div style="width: 40px;"></div>
      </div>
    </div>
    <div class="section-content-fullpage">
      <ng-container *ngTemplateOutlet="canvaTemplatesContent"></ng-container>
    </div>
  </section>

  <!-- <section class="guest-section" *ngIf="access !== 'restricted'"> -->
  <section class="guest-section" *ngIf="!isMobile || (currentSection !== 3 || !showFullPage)">

    <!-- <app-storage-upgrade-banner *ngIf="isMobile" style="display:block;margin-bottom:12px;"></app-storage-upgrade-banner> -->

    <div class="guest-header">
      <span class="invite-header">Guests</span>
      <button *ngIf="isHost === true || isHost === 'true'" class="picaggo-btn-primary" (click)="inviteUsers()"><svg
          xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="6.66667" cy="4.00065" r="2.66667" fill="white" />
          <path
            d="M11.9999 11.666C11.9999 13.3229 11.9999 14.666 6.66659 14.666C1.33325 14.666 1.33325 13.3229 1.33325 11.666C1.33325 10.0092 3.72107 8.66602 6.66659 8.66602C9.6121 8.66602 11.9999 10.0092 11.9999 11.666Z"
            fill="white" />
          <path
            d="M13.9999 6.66733H12.6666M12.6666 6.66733H11.3333M12.6666 6.66733L12.6666 5.33398M12.6666 6.66733L12.6666 8.00065"
            stroke="white" stroke-linecap="round" />
        </svg> Invite</button>
    </div>
    <div class="filter-buttons" *ngIf="collaborators?.length > 0">
      <button [ngClass]="{ 'active': selectedFilter === 'all' }" (click)="filterGuests('all')">All ({{ allCount
        }})</button>
      <button [ngClass]="{ 'active': selectedFilter === 'yes' }" (click)="filterGuests('yes')">Yes ({{ yesCount
        }})</button>
      <button [ngClass]="{ 'active': selectedFilter === 'no' }" (click)="filterGuests('no')">No ({{ noCount }})</button>
      <button [ngClass]="{ 'active': selectedFilter === 'maybe' }" (click)="filterGuests('maybe')">Maybe ({{ maybeCount
        }})</button>
    </div>
    <div style="display: flex;justify-content: center;">
      <span *ngIf="isGuestLoading" class="loader" style="margin-top: 10%;"></span>
    </div>
    <div *ngIf="collaborators?.length > 0 && !isGuestLoading">
      <div class="guest-list">
        <div class="guest-card-wrapper" *ngFor="let guest of filteredGuests; let i = index"
          [class.pending-transfer]="hostTransferPendingUserId === guest.user_id?.toString()">
          <div class="guest-card">
            <div class="collab-avatar" *ngIf="guest.imageUrl; else initials"
              [ngStyle]="{ 'background': 'url(' + guest.imageUrl + ')  lightgray 50% / cover no-repeat' }">
              <div class="collab_icon" *ngIf="guest.access_type == 'write'">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M5.33325 2.66667C5.33325 2.29848 5.60877 2 5.94864 2H10.0512C10.3911 2 10.6666 2.29848 10.6666 2.66667C10.6666 3.03486 10.3911 3.33333 10.0512 3.33333H5.94864C5.60877 3.33333 5.33325 3.03486 5.33325 2.66667Z"
                    fill="white" />
                  <path
                    d="M6.33336 9.00023C6.33336 8.11261 7.07955 7.39306 8.00003 7.39306C8.9205 7.39306 9.66669 8.11261 9.66669 9.00023C9.66669 9.88784 8.9205 10.6074 8.00003 10.6074C7.07955 10.6074 6.33336 9.88784 6.33336 9.00023Z"
                    fill="white" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M9.4814 14H6.51844C4.43775 14 3.39741 14 2.65008 13.5185C2.32655 13.31 2.04877 13.0422 1.8326 12.7302C1.33325 12.0095 1.33325 11.0063 1.33325 8.99992V8.99859C1.33325 6.99307 1.33325 5.99031 1.83249 5.26982C2.04866 4.95784 2.32644 4.68998 2.64997 4.48152C3.3973 4 4.43764 4 6.51833 4H9.48129C11.562 4 12.6023 4 13.3496 4.48152C13.6732 4.68998 13.951 4.95784 14.1671 5.26982C14.6665 5.99047 14.6666 6.99351 14.6666 8.99992C14.6666 11.0063 14.6666 12.0095 14.1672 12.7302C13.9511 13.0422 13.6733 13.31 13.3498 13.5185C12.6024 14 11.5621 14 9.4814 14ZM5.22225 9.00023C5.22225 7.52087 6.4659 6.32161 8.00003 6.32161C9.53415 6.32161 10.7778 7.52087 10.7778 9.00023C10.7778 10.4796 9.53415 11.6788 8.00003 11.6788C6.4659 11.6788 5.22225 10.4796 5.22225 9.00023ZM11.5185 6.85734C11.5185 6.56147 11.7673 6.32161 12.0741 6.32161H12.4445C12.7513 6.32161 13 6.56147 13 6.85734C13 7.15321 12.7513 7.39306 12.4445 7.39306H12.0741C11.7673 7.39306 11.5185 7.15321 11.5185 6.85734Z"
                    fill="white" />
                </svg>
              </div>
              <div class="viewer_icon" *ngIf="guest.access_type == 'read'">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M6.49992 7.99935C6.49992 7.17092 7.17149 6.49935 7.99992 6.49935C8.82835 6.49935 9.49992 7.17092 9.49992 7.99935C9.49992 8.82778 8.82835 9.49935 7.99992 9.49935C7.17149 9.49935 6.49992 8.82778 6.49992 7.99935Z"
                    fill="white" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M1.33325 7.99935C1.33325 9.09227 1.61656 9.46033 2.18318 10.1965C3.31456 11.6663 5.21199 13.3327 7.99992 13.3327C10.7878 13.3327 12.6853 11.6663 13.8167 10.1965C14.3833 9.46033 14.6666 9.09227 14.6666 7.99935C14.6666 6.90643 14.3833 6.53837 13.8167 5.80224C12.6853 4.33239 10.7878 2.66602 7.99992 2.66602C5.21199 2.66602 3.31456 4.33239 2.18318 5.80224C1.61656 6.53837 1.33325 6.90643 1.33325 7.99935ZM7.99992 5.49935C6.61921 5.49935 5.49992 6.61864 5.49992 7.99935C5.49992 9.38006 6.61921 10.4993 7.99992 10.4993C9.38063 10.4993 10.4999 9.38006 10.4999 7.99935C10.4999 6.61864 9.38063 5.49935 7.99992 5.49935Z"
                    fill="white" />
                </svg>
              </div>
              <!-- <img [src]="guest.imageUrl" [alt]="guest.name" /> -->
            </div>
            <ng-template #initials>
              <div class="collab-avatar fallback">
                {{ guest.name?.charAt(0)?.toUpperCase() }}

                <div class="collab_icon2" *ngIf="guest.access_type == 'write'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M5.33325 2.66667C5.33325 2.29848 5.60877 2 5.94864 2H10.0512C10.3911 2 10.6666 2.29848 10.6666 2.66667C10.6666 3.03486 10.3911 3.33333 10.0512 3.33333H5.94864C5.60877 3.33333 5.33325 3.03486 5.33325 2.66667Z"
                      fill="white" />
                    <path
                      d="M6.33336 9.00023C6.33336 8.11261 7.07955 7.39306 8.00003 7.39306C8.9205 7.39306 9.66669 8.11261 9.66669 9.00023C9.66669 9.88784 8.9205 10.6074 8.00003 10.6074C7.07955 10.6074 6.33336 9.88784 6.33336 9.00023Z"
                      fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M9.4814 14H6.51844C4.43775 14 3.39741 14 2.65008 13.5185C2.32655 13.31 2.04877 13.0422 1.8326 12.7302C1.33325 12.0095 1.33325 11.0063 1.33325 8.99992V8.99859C1.33325 6.99307 1.33325 5.99031 1.83249 5.26982C2.04866 4.95784 2.32644 4.68998 2.64997 4.48152C3.3973 4 4.43764 4 6.51833 4H9.48129C11.562 4 12.6023 4 13.3496 4.48152C13.6732 4.68998 13.951 4.95784 14.1671 5.26982C14.6665 5.99047 14.6666 6.99351 14.6666 8.99992C14.6666 11.0063 14.6666 12.0095 14.1672 12.7302C13.9511 13.0422 13.6733 13.31 13.3498 13.5185C12.6024 14 11.5621 14 9.4814 14ZM5.22225 9.00023C5.22225 7.52087 6.4659 6.32161 8.00003 6.32161C9.53415 6.32161 10.7778 7.52087 10.7778 9.00023C10.7778 10.4796 9.53415 11.6788 8.00003 11.6788C6.4659 11.6788 5.22225 10.4796 5.22225 9.00023ZM11.5185 6.85734C11.5185 6.56147 11.7673 6.32161 12.0741 6.32161H12.4445C12.7513 6.32161 13 6.56147 13 6.85734C13 7.15321 12.7513 7.39306 12.4445 7.39306H12.0741C11.7673 7.39306 11.5185 7.15321 11.5185 6.85734Z"
                      fill="white" />
                  </svg>
                </div>
                <div class="viewer_icon2" *ngIf="guest.access_type == 'read'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M6.49992 7.99935C6.49992 7.17092 7.17149 6.49935 7.99992 6.49935C8.82835 6.49935 9.49992 7.17092 9.49992 7.99935C9.49992 8.82778 8.82835 9.49935 7.99992 9.49935C7.17149 9.49935 6.49992 8.82778 6.49992 7.99935Z"
                      fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M1.33325 7.99935C1.33325 9.09227 1.61656 9.46033 2.18318 10.1965C3.31456 11.6663 5.21199 13.3327 7.99992 13.3327C10.7878 13.3327 12.6853 11.6663 13.8167 10.1965C14.3833 9.46033 14.6666 9.09227 14.6666 7.99935C14.6666 6.90643 14.3833 6.53837 13.8167 5.80224C12.6853 4.33239 10.7878 2.66602 7.99992 2.66602C5.21199 2.66602 3.31456 4.33239 2.18318 5.80224C1.61656 6.53837 1.33325 6.90643 1.33325 7.99935ZM7.99992 5.49935C6.61921 5.49935 5.49992 6.61864 5.49992 7.99935C5.49992 9.38006 6.61921 10.4993 7.99992 10.4993C9.38063 10.4993 10.4999 9.38006 10.4999 7.99935C10.4999 6.61864 9.38063 5.49935 7.99992 5.49935Z"
                      fill="white" />
                  </svg>
                </div>
              </div>
            </ng-template>
            <div class="guest-info">
              <span class="guest-name">{{ guest.name }}</span>
              <p class="guest-subtext"> <span *ngIf="eventData?.rsvp == 1">{{ guest.guests }} Guests • </span><span>{{
                  guest.totalFiles ? guest.totalFiles : 0 }} Photos</span></p>
            </div>

            <span class="status" [ngClass]="guest.digitalRSVP.toLowerCase()">{{ guest.digitalRSVP }}</span>
            <div class="more-container" (clickOutside)="closeMenu()" *ngIf="isHost == true || isHost == 'true'">
              <button class="more-btn" (click)="toggleMenu(i,$event)"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <circle cx="12" cy="5" r="2" transform="rotate(90 12 5)" stroke="#131A26" stroke-width="1.5"/>
  <circle cx="12" cy="12" r="2" transform="rotate(90 12 12)" stroke="#131A26" stroke-width="1.5"/>
  <circle cx="12" cy="19" r="2" transform="rotate(90 12 19)" stroke="#1C274C" stroke-width="1.5"/>
</svg></button>
            </div>
          </div>
          <!-- Host transfer pending callout -->
          <div class="host-transfer-callout" *ngIf="hostTransferPendingUserId === guest.user_id?.toString()">
            <span class="callout-text">Request to assign {{ guest.name }} as host has been sent. Waiting for confirmation.</span>
            <button class="callout-cancel-btn" (click)="cancelHostTransfer(guest.user_id.toString())">Cancel Request</button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="collaborators?.length === 0 && !isGuestLoading"
      style="text-align: center; margin-top: 10%; font-size: large;color:darkgray">
      You have not invited anybody to this event yet!
    </div>

  </section>
</div>

<!-- Change Host Confirmation Modal -->
<div class="request-host-overlay" *ngIf="showChangeHostModal" (click)="cancelHostTransferModal()">
  <div class="request-host-modal" (click)="$event.stopPropagation()">
    <button class="rh-close-btn" (click)="cancelHostTransferModal()">&#x2715;</button>

    <!-- Confirm state -->
    <ng-container *ngIf="!hostTransferSent">
      <div class="rh-icon-outer">
        <div class="rh-center-icon rh-icon-transfer">
         <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="64" height="64" rx="32" fill="#F0F0F0"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M45.3337 32.0001C45.3337 39.3639 39.3641 45.3334 32.0003 45.3334C24.6365 45.3334 18.667 39.3639 18.667 32.0001C18.667 24.6363 24.6365 18.6667 32.0003 18.6667C39.3641 18.6667 45.3337 24.6363 45.3337 32.0001ZM25.3337 35.6667L36.0003 35.6667L33.4261 37.9133C33.01 38.2765 32.9671 38.9082 33.3302 39.3243C33.6934 39.7404 34.3251 39.7833 34.7412 39.4202L39.3245 35.4202C39.6386 35.1461 39.7497 34.7059 39.6033 34.3156C39.457 33.9253 39.0838 33.6667 38.667 33.6667L25.3337 33.6667C24.7814 33.6667 24.3337 34.1145 24.3337 34.6667C24.3337 35.219 24.7814 35.6667 25.3337 35.6667ZM30.6704 24.6759C31.0336 25.092 30.9906 25.7237 30.5745 26.0868L28.0003 28.3334H38.667C39.2193 28.3334 39.667 28.7811 39.667 29.3334C39.667 29.8857 39.2193 30.3334 38.667 30.3334H25.3337C24.9168 30.3334 24.5437 30.0748 24.3973 29.6845C24.251 29.2942 24.3621 28.8541 24.6761 28.58L29.2595 24.58C29.6756 24.2168 30.3073 24.2598 30.6704 24.6759Z" fill="black"/>
</svg>

        </div>
      </div>
      <div class="rh-title rh-title-center">Send a request to Assign {{ selectedGuestForHostTransfer?.name }} as host
      </div>
      <div class="rh-desc">After accepting the request, your role will switch to collaborator where you can view, upload
        and manage media in the event album.</div>
      <div class="rh-storage-pill" *ngIf="eventStorage">
        <div class="rh-storage-pill-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C12.3415 2 12.5122 2 12.6858 2.01515C13.4951 2.08581 14.2874 2.414 14.9097 2.93631C15.0431 3.04835 15.1668 3.17206 15.4142 3.41944L20.5806 8.58578C20.828 8.83317 20.9516 8.95687 21.0637 9.09034C21.586 9.71257 21.9142 10.5049 21.9848 11.3142C22 11.4878 22 11.6585 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22ZM13 5.25C13.4142 5.25 13.75 5.58579 13.75 6V9C13.75 9.41421 13.4142 9.75 13 9.75C12.5858 9.75 12.25 9.41421 12.25 9V6C12.25 5.58579 12.5858 5.25 13 5.25ZM10.75 6C10.75 5.58579 10.4142 5.25 10 5.25C9.58579 5.25 9.25 5.58579 9.25 6V9C9.25 9.41421 9.58579 9.75 10 9.75C10.4142 9.75 10.75 9.41421 10.75 9V6ZM7 5.25C7.41421 5.25 7.75 5.58579 7.75 6V9C7.75 9.41421 7.41421 9.75 7 9.75C6.58579 9.75 6.25 9.41421 6.25 9V6C6.25 5.58579 6.58579 5.25 7 5.25Z" fill="currentColor"/>
          </svg>
        </div>
        <span>You will get back {{ eventStorage }} of storage</span>
      </div>
      <button class="rh-send-btn rh-send-btn-full" (click)="sendHostTransferRequest()"
        [disabled]="isHostTransferLoading">
        <span *ngIf="!isHostTransferLoading">Send Request</span>
        <span *ngIf="isHostTransferLoading" class="loader-small"></span>
      </button>
    </ng-container>

    <!-- Success state -->
    <ng-container *ngIf="hostTransferSent">
      <div class="rh-center-icon rh-icon-success">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="64" height="64" rx="32" fill="#DDF0E0" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M45.3337 32.0001C45.3337 39.3639 39.3641 45.3334 32.0003 45.3334C24.6365 45.3334 18.667 39.3639 18.667 32.0001C18.667 24.6363 24.6365 18.6667 32.0003 18.6667C39.3641 18.6667 45.3337 24.6363 45.3337 32.0001ZM37.3741 27.9596C37.7646 28.3502 37.7646 28.9833 37.3741 29.3739L30.7074 36.0405C30.3169 36.431 29.6837 36.431 29.2932 36.0405L26.6266 33.3739C26.236 32.9833 26.236 32.3502 26.6266 31.9596C27.0171 31.5691 27.6502 31.5691 28.0408 31.9596L30.0003 33.9192L32.9801 30.9394L35.9599 27.9596C36.3504 27.5691 36.9836 27.5691 37.3741 27.9596Z"
            fill="#1FAF38" />
        </svg>

      </div>
      <div class="rh-title rh-title-center">Request sent</div>
      <div class="rh-desc">Once the recipient accepts the request, we will notify you</div>
      <button class="rh-send-btn rh-send-btn-full" (click)="openEventAlbum()">Open Event Album</button>
    </ng-container>
  </div>
</div>

<!-- Confirmation Modal - Visible in both mobile and desktop -->
<app-confirmation-modal *ngIf="showConfirmModal" [confirmMessage]="confirmMessage" [isHomePage]="false"
  (confirmed)="onChangeConfirmed($event)"></app-confirmation-modal>

<ng-template [ngIf]="isLoading">
  <!-- <div class="fade-background" [class.show]="isLoading" name="fade-div"> -->
  <div class="overlay1" style="height:100vh;">
    <!-- <div class="ring">
      <svg width="76" height="31" viewBox="0 0 96 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M63.7782 2.95119H76.0185V0.975586H63.7782V2.95119ZM18.6251 10.6671C18.6251 9.75786 19.3622 9.02077 20.2715 9.02077H72.7718C73.6811 9.02077 74.4182 9.75786 74.4182 10.6671V32.884C74.4182 33.7932 73.6811 34.5303 72.7718 34.5303H56.6308C59.9348 32.223 62.099 28.3725 62.099 24.0121C62.099 16.9518 56.425 11.2283 49.4257 11.2283C48.5014 11.2283 47.6001 11.3282 46.732 11.5177H27.2898C25.313 11.5177 23.7251 13.1318 23.7251 15.1049V37.3913C23.7251 39.3643 25.313 40.9784 27.2898 40.9784H96V39.0028H27.2898C26.4202 39.0028 25.7007 38.2894 25.7007 37.3913V15.1049C25.7007 14.2067 26.4202 13.4933 27.2898 13.4933H42.2215C38.9171 15.8005 36.7525 19.6513 36.7525 24.0121C36.7525 31.0724 42.4265 36.7959 49.4257 36.7959C50.3511 36.7959 51.2534 36.6959 52.1224 36.5059H72.7718C74.7722 36.5059 76.3938 34.8843 76.3938 32.884V10.6671C76.3938 8.66676 74.7722 7.04517 72.7718 7.04517H20.2715C18.2711 7.04517 16.6495 8.66677 16.6495 10.6671V28.6144C16.6495 29.5237 15.9124 30.2608 15.0032 30.2608H0V32.2364H15.0032C17.0035 32.2364 18.6251 30.6148 18.6251 28.6144V10.6671ZM60.1234 24.0121C60.1234 29.9975 55.3178 34.8203 49.4257 34.8203C43.5337 34.8203 38.7281 29.9975 38.7281 24.0121C38.7281 18.0267 43.5337 13.2039 49.4257 13.2039C55.3178 13.2039 60.1234 18.0267 60.1234 24.0121Z"
          fill="white" />
      </svg>
      <span class="loader"></span>
    </div> -->
    <span class="loader"></span>
  </div>
  <!-- </div> -->
</ng-template>

<!-- event-settings.component.html -->
<div style="width: 50%;height: 60px;" *ngIf="!isMobile">
  <button (click)="goBack()" class="back-btn" style="padding: 12px 16px;"><svg width="40" height="40"
      viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="white" />
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
      <path d="M28 20H12M12 20L18 14M12 20L18 26" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </button>
  <span style="float: right; font-size: 20px;line-height: 30px;font-weight: 600;
    font-family: 'Manrope'; padding-top: 16px;">Event Settings</span>
</div>
<div class="event-settings-wrapper" *ngIf="!isMobile">
  <div class="sidebar">
    <div class="card1">
      <div class="card1-header">
        <div class="profile1">
          <img *ngIf="coverImage" [src]="coverImage" alt="Profile" class="avatar1"
            onerror="this.onerror=null;this.src='/assets/images/default_cover.png'" />
          <img *ngIf="!coverImage" src="/assets/images/default_cover.png" alt="Profile" class="avatar1" />
          <div class="info1">
            <div class="title1 text-overflow">{{ eventData.eventName }}</div>
            <div class="subtitle1">{{inviteData?.host_name}}</div>
            <div class="event-meta-chips" style="margin-top: 6px;">

              <span class="meta-chip" *ngIf="eventImageCount > 0">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                  style="vertical-align:middle;margin-right:3px">
                  <path
                    d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM5 15L8.5 10.5L11 13.5L14.5 9L19 15H5Z"
                    fill="currentColor" />
                </svg>
                {{ eventImageCount }} photos
              </span>
              <span class="meta-chip" *ngIf="eventVideoCount > 0">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                  style="vertical-align:middle;margin-right:3px">
                  <path
                    d="M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5Z"
                    fill="currentColor" />
                </svg>
                {{ eventVideoCount }} videos
              </span>
              <span class="meta-chip" *ngIf="eventStorageBytes > 0">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                  style="vertical-align:middle;margin-right:3px">
                  <path d="M2 20H22V4H2V20ZM4 6H20V14H4V6ZM6 8V12H18V8H6Z" fill="currentColor" />
                </svg>
                {{ eventStorage }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngFor="let section of sections; let i = index">
      <div *ngIf="i === 1 || i === 2" [class.active]="currentSection === i" (click)="currentSection = i">
        <div class="section-title-{{i+1}}">
          <span>{{ section.title }}</span>
          <div class="nav-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- <div class="menu-item"  *ngIf="isHost == true || isHost == 'true'"  (click)="toggleBranding()">
      <span>Show Branding</span> <span *ngIf="isBrandingEnabled" style="color: green;"> Yes</span><span *ngIf="!isBrandingEnabled" style="color: red;"> No</span>
    </div> -->
    <div class="section-title-3" *ngIf="isHost == true || isHost == 'true'" [class.active]="currentSection === 3"
      (click)="currentSection = 3">
      <span>Landing Page</span>
      <div class="nav-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
    <div class="section-title-4" *ngIf="isHost == true || isHost == 'true'" [class.active]="currentSection === 4"
      (click)="currentSection = 4">
      <span>Bulk Download</span>
      <div class="nav-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
    <div class="section-title-7" *ngIf="env.features.manageEventHub && (isHost == true || isHost == 'true')" [class.active]="currentSection === 7"
      (click)="currentSection = 7">
      <span>Sorting Order</span>
      <div class="nav-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
    <div class="section-title-8" *ngIf="env.features.manageEventHub && (isHost == true || isHost == 'true')" [class.active]="currentSection === 8"
      (click)="currentSection = 8">
      <span>Guest Uploads</span>
      <div class="nav-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
    <div class="section-title-5" *ngIf="(isHost == true || isHost == 'true') && canUseBranding && env.features.eventBranding"
      [class.active]="currentSection === 5" (click)="showBranding()">
      <span>Branding</span>
      <div class="nav-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
    <div class="section-title-6" *ngIf="isHost == true || isHost == 'true'"
      [class.active]="currentSection === 6" (click)="showTemplates()">
      <span>Templates</span>
      <div class="nav-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M9 5L15 12L9 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
    <div class="section-title-1" *ngIf="isHost == false || isHost == 'false'" (click)="confirmExit()">
      <span>Exit Event</span>
    </div>
    <div class="section-title-1" *ngIf="isHost == true || isHost == 'true'" (click)="confirmDelete()">
      <span>Delete Event</span>
    </div>
  </div>
  <div class="content-area">
    <ng-container [ngSwitch]="currentSection">
      <div *ngSwitchCase="1" class="section-content" style="width:600px;margin: 0 auto;">
        <form [formGroup]="newEventForm" class="eventForm">
          <div class="header-2" style="float: left;">Event Details</div>
          <div>
            <button *ngIf="!isEditable && (isHost === true || isHost === 'true')" (click)="toggleEdit()" type="button"
              class="picaggo-btn-primary" style="float: right;">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M3.25 22C3.25 21.5858 3.58579 21.25 4 21.25H20C20.4142 21.25 20.75 21.5858 20.75 22C20.75 22.4142 20.4142 22.75 20 22.75H4C3.58579 22.75 3.25 22.4142 3.25 22Z"
                  fill="white" />
                <path
                  d="M11.5201 14.929L11.5201 14.9289L17.4368 9.01225C16.6315 8.6771 15.6777 8.12656 14.7757 7.22455C13.8736 6.32238 13.323 5.36846 12.9879 4.56312L7.07106 10.4799L7.07101 10.48C6.60932 10.9417 6.37846 11.1725 6.17992 11.4271C5.94571 11.7273 5.74491 12.0522 5.58107 12.396C5.44219 12.6874 5.33894 12.9972 5.13245 13.6167L4.04356 16.8833C3.94194 17.1882 4.02128 17.5243 4.2485 17.7515C4.47573 17.9787 4.81182 18.0581 5.11667 17.9564L8.38334 16.8676C9.00281 16.6611 9.31256 16.5578 9.60398 16.4189C9.94775 16.2551 10.2727 16.0543 10.5729 15.8201C10.8275 15.6215 11.0584 15.3907 11.5201 14.929Z"
                  fill="white" />
                <path
                  d="M19.0786 7.37044C20.3071 6.14188 20.3071 4.14999 19.0786 2.92142C17.85 1.69286 15.8581 1.69286 14.6296 2.92142L13.9199 3.63105C13.9296 3.6604 13.9397 3.69015 13.9502 3.72028C14.2103 4.47 14.701 5.45281 15.6243 6.37602C16.5475 7.29923 17.5303 7.78999 18.28 8.05009C18.31 8.0605 18.3396 8.07054 18.3688 8.08021L19.0786 7.37044Z"
                  fill="white" />
              </svg>
              Edit </button>
          </div>
          <div class="event-content">
            <div class="form-group">
              <label for="eventName">Event Name</label>
              <input matInput id="eventName" formControlName="eventName" type="text" placeholder="Enter Event Name" />
              <div *ngIf="formControls.eventName.touched && formControls.eventName.invalid" class="alert alert-danger">
                Title is required.
              </div>
              <mat-hint align="end" style="font-size: x-small;color:gray">
                {{ formControls.eventName.value?.length || 0 }}/200 characters
              </mat-hint>
            </div>
            <div class="form-group">
              <label for="hostedBy">Host</label>
              <input matInput id="hostedBy" formControlName="hostedBy" type="text" placeholder="Add Host Name" />
              <!-- <div *ngIf="formControls.hostedBy.touched && formControls.hostedBy.invalid" class="alert alert-danger">
                Host Name is required.
              </div> -->
              <mat-error *ngIf="newEventForm.hasError('hostedByRequired')">
                Hosted By is required for future events.
              </mat-error>
            </div>
            <div class="form-group">
              <label for="eventCategory">Event Category</label>
              <div class="category-pills">
                <button type="button" class="category-pill"
                  *ngFor="let pill of categoryPills"
                  [class.selected]="isPillSelected(pill)"
                  (click)="selectCategoryPill(pill)">
                  {{ pill }}
                </button>
              </div>

              <!-- Custom name input, shown only when "Other" is selected -->
              <div *ngIf="showOtherCategoryInput" style="margin-top: 10px;">
                <div class="custom-input-wrapper">
                  <input type="text" maxlength="50" matInput formControlName="eventCategory"
                    placeholder="Enter category name" class="custom-input" />
                </div>
                <div class="char-count-hint">
                  {{ formControls.eventCategory.value?.length || 0 }}/50 characters
                </div>
              </div>

              <div *ngIf="formControls.eventCategory.touched && formControls.eventCategory.invalid"
                style="padding: 5px; margin-bottom: 2px" class="alert alert-danger">
                <p style="margin: 0 !important" class="error">
                  Category Selection is required.
                </p>
              </div>
            </div>
          </div>
          <div class="header-2">Event Duration</div>
          <!-- <div class="form-group">
            <label>Timezone</label>
            <div style="position: relative;">
              <div class="custom-input-wrapper" style="margin-bottom: 0;">
                <input type="text" [(ngModel)]="timezoneSearchText" (ngModelChange)="filterTimezones($event)"
                  (focus)="onTimezoneInputFocus()" (blur)="closeTimezoneDropdown()"
                  [ngModelOptions]="{standalone: true}"
                  [placeholder]="timezoneSearchText ? 'Search timezone...' : getSelectedTimezoneLabel()"
                  class="custom-input" [disabled]="!isEditable">
                <svg class="input-icon" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <circle cx="8" cy="8" r="6" stroke="#666" stroke-width="1.5" />
                  <path d="M12.5 12.5L16 16" stroke="#666" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </div>
              Hidden select to maintain form control
              <select formControlName="timezone" style="display: none;">
                <option *ngFor="let tz of timezones" [value]="tz.value">{{tz.label}}</option>
              </select>
              Custom dropdown list
              <div *ngIf="showTimezoneDropdown" class="timezone-dropdown">
                <div *ngFor="let tz of filteredTimezones" class="timezone-option" (mousedown)="selectTimezone(tz)">
                  {{tz.label}}
                </div>
                <div *ngIf="filteredTimezones.length === 0" class="timezone-option" style="color: #999;">
                  No timezones found
                </div>
              </div>
            </div>
          </div> -->

          <div class="form-group">
            <label>Start</label>
            <div *ngIf="isAnyLive == 'true'"
              style="color: red;font-weight: 600;font-family: 'Manrope'; text-align: center; margin-bottom: 12px;">You
              cannot change the
              start date of any event while a live event is in progress. Please wait until the current live event
              ends.</div>
            <div class="date-time-grid" *ngIf="!(isAnyLive == 'true')">
              <div class="custom-input-wrapper">
                <input type="date" formControlName="startTime" [readonly]="useNow" class="custom-input"
                  (change)="onStartTimeChange($event)">
                <svg class="input-icon" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <rect x="2" y="3" width="14" height="13" rx="2" stroke="#666" stroke-width="1.5" />
                  <path d="M6 1.5V4.5M12 1.5V4.5M2 7H16" stroke="#666" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </div>
              <div class="custom-select-wrapper">
                <select formControlName="startTimeString" class="custom-select">
                  <option value="00:00">12:00 AM</option>
                  <option value="00:15">12:15 AM</option>
                  <option value="00:30">12:30 AM</option>
                  <option value="00:45">12:45 AM</option>
                  <option value="01:00">01:00 AM</option>
                  <option value="01:15">01:15 AM</option>
                  <option value="01:30">01:30 AM</option>
                  <option value="01:45">01:45 AM</option>
                  <option value="02:00">02:00 AM</option>
                  <option value="02:15">02:15 AM</option>
                  <option value="02:30">02:30 AM</option>
                  <option value="02:45">02:45 AM</option>
                  <option value="03:00">03:00 AM</option>
                  <option value="03:15">03:15 AM</option>
                  <option value="03:30">03:30 AM</option>
                  <option value="03:45">03:45 AM</option>
                  <option value="04:00">04:00 AM</option>
                  <option value="04:15">04:15 AM</option>
                  <option value="04:30">04:30 AM</option>
                  <option value="04:45">04:45 AM</option>
                  <option value="05:00">05:00 AM</option>
                  <option value="05:15">05:15 AM</option>
                  <option value="05:30">05:30 AM</option>
                  <option value="05:45">05:45 AM</option>
                  <option value="06:00">06:00 AM</option>
                  <option value="06:15">06:15 AM</option>
                  <option value="06:30">06:30 AM</option>
                  <option value="06:45">06:45 AM</option>
                  <option value="07:00">07:00 AM</option>
                  <option value="07:15">07:15 AM</option>
                  <option value="07:30">07:30 AM</option>
                  <option value="07:45">07:45 AM</option>
                  <option value="08:00">08:00 AM</option>
                  <option value="08:15">08:15 AM</option>
                  <option value="08:30">08:30 AM</option>
                  <option value="08:45">08:45 AM</option>
                  <option value="09:00">09:00 AM</option>
                  <option value="09:15">09:15 AM</option>
                  <option value="09:30">09:30 AM</option>
                  <option value="09:45">09:45 AM</option>
                  <option value="10:00">10:00 AM</option>
                  <option value="10:15">10:15 AM</option>
                  <option value="10:30">10:30 AM</option>
                  <option value="10:45">10:45 AM</option>
                  <option value="11:00">11:00 AM</option>
                  <option value="11:15">11:15 AM</option>
                  <option value="11:30">11:30 AM</option>
                  <option value="11:45">11:45 AM</option>
                  <option value="12:00">12:00 PM</option>
                  <option value="12:15">12:15 PM</option>
                  <option value="12:30">12:30 PM</option>
                  <option value="12:45">12:45 PM</option>
                  <option value="13:00">01:00 PM</option>
                  <option value="13:15">01:15 PM</option>
                  <option value="13:30">01:30 PM</option>
                  <option value="13:45">01:45 PM</option>
                  <option value="14:00">02:00 PM</option>
                  <option value="14:15">02:15 PM</option>
                  <option value="14:30">02:30 PM</option>
                  <option value="14:45">02:45 PM</option>
                  <option value="15:00">03:00 PM</option>
                  <option value="15:15">03:15 PM</option>
                  <option value="15:30">03:30 PM</option>
                  <option value="15:45">03:45 PM</option>
                  <option value="16:00">04:00 PM</option>
                  <option value="16:15">04:15 PM</option>
                  <option value="16:30">04:30 PM</option>
                  <option value="16:45">04:45 PM</option>
                  <option value="17:00">05:00 PM</option>
                  <option value="17:15">05:15 PM</option>
                  <option value="17:30">05:30 PM</option>
                  <option value="17:45">05:45 PM</option>
                  <option value="18:00">06:00 PM</option>
                  <option value="18:15">06:15 PM</option>
                  <option value="18:30">06:30 PM</option>
                  <option value="18:45">06:45 PM</option>
                  <option value="19:00">07:00 PM</option>
                  <option value="19:15">07:15 PM</option>
                  <option value="19:30">07:30 PM</option>
                  <option value="19:45">07:45 PM</option>
                  <option value="20:00">08:00 PM</option>
                  <option value="20:15">08:15 PM</option>
                  <option value="20:30">08:30 PM</option>
                  <option value="20:45">08:45 PM</option>
                  <option value="21:00">09:00 PM</option>
                  <option value="21:15">09:15 PM</option>
                  <option value="21:30">09:30 PM</option>
                  <option value="21:45">09:45 PM</option>
                  <option value="22:00">10:00 PM</option>
                  <option value="22:15">10:15 PM</option>
                  <option value="22:30">10:30 PM</option>
                  <option value="22:45">10:45 PM</option>
                  <option value="23:00">11:00 PM</option>
                  <option value="23:15">11:15 PM</option>
                  <option value="23:30">11:30 PM</option>
                  <option value="23:45">11:45 PM</option>
                </select>
                <svg class="select-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none">
                  <path d="M1 1.5L6 6.5L11 1.5" stroke="#666" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
            </div>
            <div *ngIf="newEventForm.controls['startTime'].hasError('pastDate')" class="alert alert-danger">
              <p class="error">Start time cannot be in the past.</p>
            </div>
            <label class="checkbox-inline" *ngIf="isEditable && !(isAnyLive == 'true')">
              <input type="checkbox" [(ngModel)]="useNow" [ngModelOptions]="{ standalone: true }"
                (change)="toggleNowCheckbox()" />
              <span>Start now</span>
            </label>
          </div>

          <div class="form-group">
            <label>End</label>
            <div class="date-time-grid">
              <div class="custom-input-wrapper">
                <input type="date" formControlName="endTime" class="custom-input">
                <svg class="input-icon" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <rect x="2" y="3" width="14" height="13" rx="2" stroke="#666" stroke-width="1.5" />
                  <path d="M6 1.5V4.5M12 1.5V4.5M2 7H16" stroke="#666" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </div>
              <div class="custom-select-wrapper">
                <select formControlName="endTimeString" class="custom-select">
                  <option value="00:00">12:00 AM</option>
                  <option value="00:15">12:15 AM</option>
                  <option value="00:30">12:30 AM</option>
                  <option value="00:45">12:45 AM</option>
                  <option value="01:00">01:00 AM</option>
                  <option value="01:15">01:15 AM</option>
                  <option value="01:30">01:30 AM</option>
                  <option value="01:45">01:45 AM</option>
                  <option value="02:00">02:00 AM</option>
                  <option value="02:15">02:15 AM</option>
                  <option value="02:30">02:30 AM</option>
                  <option value="02:45">02:45 AM</option>
                  <option value="03:00">03:00 AM</option>
                  <option value="03:15">03:15 AM</option>
                  <option value="03:30">03:30 AM</option>
                  <option value="03:45">03:45 AM</option>
                  <option value="04:00">04:00 AM</option>
                  <option value="04:15">04:15 AM</option>
                  <option value="04:30">04:30 AM</option>
                  <option value="04:45">04:45 AM</option>
                  <option value="05:00">05:00 AM</option>
                  <option value="05:15">05:15 AM</option>
                  <option value="05:30">05:30 AM</option>
                  <option value="05:45">05:45 AM</option>
                  <option value="06:00">06:00 AM</option>
                  <option value="06:15">06:15 AM</option>
                  <option value="06:30">06:30 AM</option>
                  <option value="06:45">06:45 AM</option>
                  <option value="07:00">07:00 AM</option>
                  <option value="07:15">07:15 AM</option>
                  <option value="07:30">07:30 AM</option>
                  <option value="07:45">07:45 AM</option>
                  <option value="08:00">08:00 AM</option>
                  <option value="08:15">08:15 AM</option>
                  <option value="08:30">08:30 AM</option>
                  <option value="08:45">08:45 AM</option>
                  <option value="09:00">09:00 AM</option>
                  <option value="09:15">09:15 AM</option>
                  <option value="09:30">09:30 AM</option>
                  <option value="09:45">09:45 AM</option>
                  <option value="10:00">10:00 AM</option>
                  <option value="10:15">10:15 AM</option>
                  <option value="10:30">10:30 AM</option>
                  <option value="10:45">10:45 AM</option>
                  <option value="11:00">11:00 AM</option>
                  <option value="11:15">11:15 AM</option>
                  <option value="11:30">11:30 AM</option>
                  <option value="11:45">11:45 AM</option>
                  <option value="12:00">12:00 PM</option>
                  <option value="12:15">12:15 PM</option>
                  <option value="12:30">12:30 PM</option>
                  <option value="12:45">12:45 PM</option>
                  <option value="13:00">01:00 PM</option>
                  <option value="13:15">01:15 PM</option>
                  <option value="13:30">01:30 PM</option>
                  <option value="13:45">01:45 PM</option>
                  <option value="14:00">02:00 PM</option>
                  <option value="14:15">02:15 PM</option>
                  <option value="14:30">02:30 PM</option>
                  <option value="14:45">02:45 PM</option>
                  <option value="15:00">03:00 PM</option>
                  <option value="15:15">03:15 PM</option>
                  <option value="15:30">03:30 PM</option>
                  <option value="15:45">03:45 PM</option>
                  <option value="16:00">04:00 PM</option>
                  <option value="16:15">04:15 PM</option>
                  <option value="16:30">04:30 PM</option>
                  <option value="16:45">04:45 PM</option>
                  <option value="17:00">05:00 PM</option>
                  <option value="17:15">05:15 PM</option>
                  <option value="17:30">05:30 PM</option>
                  <option value="17:45">05:45 PM</option>
                  <option value="18:00">06:00 PM</option>
                  <option value="18:15">06:15 PM</option>
                  <option value="18:30">06:30 PM</option>
                  <option value="18:45">06:45 PM</option>
                  <option value="19:00">07:00 PM</option>
                  <option value="19:15">07:15 PM</option>
                  <option value="19:30">07:30 PM</option>
                  <option value="19:45">07:45 PM</option>
                  <option value="20:00">08:00 PM</option>
                  <option value="20:15">08:15 PM</option>
                  <option value="20:30">08:30 PM</option>
                  <option value="20:45">08:45 PM</option>
                  <option value="21:00">09:00 PM</option>
                  <option value="21:15">09:15 PM</option>
                  <option value="21:30">09:30 PM</option>
                  <option value="21:45">09:45 PM</option>
                  <option value="22:00">10:00 PM</option>
                  <option value="22:15">10:15 PM</option>
                  <option value="22:30">10:30 PM</option>
                  <option value="22:45">10:45 PM</option>
                  <option value="23:00">11:00 PM</option>
                  <option value="23:15">11:15 PM</option>
                  <option value="23:30">11:30 PM</option>
                  <option value="23:45">11:45 PM</option>
                </select>
                <svg class="select-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none">
                  <path d="M1 1.5L6 6.5L11 1.5" stroke="#666" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
            </div>
            <div *ngIf="newEventForm.errors?.['endBeforeStart']" class="alert alert-danger">
              <p class="error">End Time must be after Start Time.</p>
            </div>
            <div *ngIf="newEventForm.errors?.['durationExceedsLimit']" class="alert alert-danger">
              <p class="error">Event duration cannot exceed 10 days.</p>
            </div>
          </div>
          <div class="event-duration" *ngIf="eventDuration">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 8.02944 7.02944 4 12 4C16.9706 4 21 8.02944 21 13Z"
                stroke="currentColor" stroke-width="1.5" />
              <path d="M12 13V9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M10 2H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <div class="event-duration-text">
              Event set for {{ eventDuration }}</div>
          </div>
          <div class="event-header">
            <div *ngIf="coverImage == null" class="image-container">
              <button *ngIf="isEditable" type="button" (click)="changeCover()" class="addcover_btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M21.9998 12.6978C21.9983 14.1674 21.9871 15.4165 21.9036 16.4414C21.8067 17.6308 21.6081 18.6246 21.1636 19.45C20.9676 19.814 20.7267 20.1401 20.4334 20.4334C19.601 21.2657 18.5405 21.6428 17.1966 21.8235C15.8835 22 14.2007 22 12.0534 22H11.9466C9.79929 22 8.11646 22 6.80345 21.8235C5.45951 21.6428 4.39902 21.2657 3.56664 20.4334C2.82871 19.6954 2.44763 18.777 2.24498 17.6376C2.04591 16.5184 2.00949 15.1259 2.00192 13.3967C2 12.9569 2 12.4917 2 12.0009V11.9466C1.99999 9.79929 1.99998 8.11646 2.17651 6.80345C2.3572 5.45951 2.73426 4.39902 3.56664 3.56664C4.39902 2.73426 5.45951 2.3572 6.80345 2.17651C7.97111 2.01952 9.47346 2.00215 11.302 2.00024C11.6873 1.99983 12 2.31236 12 2.69767C12 3.08299 11.6872 3.3952 11.3019 3.39561C9.44749 3.39757 8.06751 3.41446 6.98937 3.55941C5.80016 3.7193 5.08321 4.02339 4.5533 4.5533C4.02339 5.08321 3.7193 5.80016 3.55941 6.98937C3.39683 8.19866 3.39535 9.7877 3.39535 12C3.39535 12.2702 3.39535 12.5314 3.39567 12.7844L4.32696 11.9696C5.17465 11.2278 6.45225 11.2704 7.24872 12.0668L11.2392 16.0573C11.8785 16.6966 12.8848 16.7837 13.6245 16.2639L13.9019 16.0689C14.9663 15.3209 16.4064 15.4076 17.3734 16.2779L20.0064 18.6476C20.2714 18.091 20.4288 17.3597 20.5128 16.3281C20.592 15.3561 20.6029 14.1755 20.6044 12.6979C20.6048 12.3126 20.917 12 21.3023 12C21.6876 12 22.0002 12.3125 21.9998 12.6978Z"
                    fill="currentColor" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M17.5 11C15.3787 11 14.318 11 13.659 10.341C13 9.68198 13 8.62132 13 6.5C13 4.37868 13 3.31802 13.659 2.65901C14.318 2 15.3787 2 17.5 2C19.6213 2 20.682 2 21.341 2.65901C22 3.31802 22 4.37868 22 6.5C22 8.62132 22 9.68198 21.341 10.341C20.682 11 19.6213 11 17.5 11ZM18.25 4.5C18.25 4.08579 17.9142 3.75 17.5 3.75C17.0858 3.75 16.75 4.08579 16.75 4.5V5.75H15.5C15.0858 5.75 14.75 6.08579 14.75 6.5C14.75 6.91421 15.0858 7.25 15.5 7.25H16.75V8.5C16.75 8.91421 17.0858 9.25 17.5 9.25C17.9142 9.25 18.25 8.91421 18.25 8.5V7.25H19.5C19.9142 7.25 20.25 6.91421 20.25 6.5C20.25 6.08579 19.9142 5.75 19.5 5.75H18.25V4.5Z"
                    fill="currentColor" />
                </svg> Add Cover Image
              </button>
            </div>
            <div class="image-container2" *ngIf="coverImage != null">
              <img [src]="coverImage" alt="Cover Image"
                onerror="this.onerror=null;this.src='/assets/images/default_cover.png'" />
              <button *ngIf="isEditable" type="button" (click)="changeCover()" class="edit-icon2">
                <svg width="20pt" height="20pt" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m65.949 22.012c-0.75-0.75-2.0781-0.75-2.8281 0l-9.5586 9.5586-29.152 29.148c-0.14062 0.14062-0.23828 0.28906-0.32812 0.44922-0.019531 0.03125-0.039062 0.070312-0.050781 0.10156-0.078125 0.17188-0.14062 0.33984-0.17188 0.51172 0 0.011719-0.011719 0.011719-0.011719 0.019531l-2.3984 14.449c-0.10938 0.64062 0.10156 1.2891 0.55859 1.7383 0.37891 0.37891 0.89063 0.58984 1.4102 0.58984 0.10938 0 0.21875-0.011719 0.32812-0.03125l14.449-2.3984c0.011719 0 0.011719 0 0.019532-0.011719 0.17969-0.03125 0.35156-0.089844 0.51953-0.17188 0.03125-0.019532 0.070313-0.03125 0.10156-0.050782 0.16016-0.089843 0.30859-0.19141 0.44922-0.32812l38.707-38.707c0.78125-0.78125 0.78125-2.0508 0-2.8281zm-28.078 49.34-9.2188-9.2188 26.32-26.32 9.2188 9.2188zm-10.711-5.0508 6.5391 6.5391-7.8516 1.3086zm39.852-24.102-9.2188-9.2188 6.7383-6.7383 9.2109 9.2188z"
                    fill="#676767" />
                </svg>
              </button>

            </div>
          </div>
          <div class="invitation-header">Invitation</div>
          <div class="form-group">
            <label>Invitation Message</label>
            <textarea matInput formControlName="message" rows="4" placeholder="Enter Invite Message..."></textarea>

            <button class="ai-button" *ngIf="isEditable" (click)="generateMessage()">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.33333 5.83333L7.90333 6.995C7.34 8.51833 7.05833 9.28 6.5025 9.83583C5.94667 10.3917 5.185 10.6733 3.66167 11.2367L2.5 11.6667L3.66167 12.0967C5.185 12.66 5.94667 12.9425 6.5025 13.4975C7.05833 14.0525 7.34 14.815 7.90333 16.3383L8.33333 17.5L8.76333 16.3383C9.32667 14.815 9.60917 14.0533 10.1642 13.4975C10.7192 12.9417 11.4817 12.66 13.005 12.0967L14.1667 11.6667L13.005 11.2367C11.4817 10.6733 10.72 10.3917 10.1642 9.83583C9.60833 9.28 9.32667 8.51833 8.76333 6.995L8.33333 5.83333ZM15 2.5L14.8158 2.9975C14.5742 3.65083 14.4533 3.9775 14.2158 4.215C13.9775 4.45333 13.6508 4.57417 12.9975 4.815L12.5 5L12.9983 5.18417C13.6508 5.42583 13.9775 5.54667 14.215 5.78417C14.4533 6.0225 14.5742 6.34917 14.815 7.0025L15 7.5L15.1842 7.0025C15.4258 6.34917 15.5467 6.0225 15.7842 5.785C16.0225 5.54667 16.3492 5.42583 17.0025 5.185L17.5 5L17.0017 4.81583C16.3492 4.57417 16.0225 4.45333 15.785 4.21583C15.5467 3.9775 15.4258 3.65083 15.185 2.9975L15 2.5Z"
                  stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Generate with AI</button>
          </div>
          <!-- <div class="form-group">
            <div class="switch">
              <span style="float: left;color: #000;
                  font-family: 'Manrope';
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: normal;">Collect RSVP</span>
              <mat-slide-toggle *ngIf="isEditable" labelPosition="before" formControlName="rsvp" style="float: right;"
                class="slide-toggle"></mat-slide-toggle>
              <span *ngIf="!isEditable" style="float: right;font-size: 16px;font-weight: 600;">{{
                newEventForm.value.rsvp == true ? 'Yes' : 'No'}}</span>
              <br>
              <p style="font-size: 12px;color: gray;padding-top: 8px;float: left;"> <svg width="24" height="24"
                  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-opacity="0.5" stroke-width="1.5" />
                  <path d="M12 17V11" stroke="currentColor" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round" />
                  <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="currentColor" fill-opacity="0.5" />
                </svg>
                Turning on RSVP will ask guests if they’re attending and how many will join.</p>
            </div>
          </div>
          <div class="form-group">
            <label>Location</label>
            <input matInput formControlName="eventLocation" type="text" placeholder="Enter Location Here">
            <mat-error
              *ngIf="newEventForm.get('eventLocation')?.hasError('required') && newEventForm.get('eventLocation')?.touched">
              Location is required when RSVP is collected.
            </mat-error>
          </div> -->
          <div class="folders-container">
            <div class="folders-header">
              <h2 class="invitation-header">Albums</h2>

              <button *ngIf="(isHost == true || isHost == 'true') && isEditable" mat-button class="add-folder-btn"
                (click)="openFolderDialog($event, 'add')">
                <span class="plus-icon">+</span> Add Album
              </button>
            </div>
            <div class="folders-list">
              <span *ngIf="subfolders?.length === 0">No folders have been created yet!</span>
              <div class="folder-item" *ngFor="let folder of subfolders; let i = index">
                <div class="folder-name">{{ folder.subfolder_name }}</div>
                <div class="folder-actions">
                  <button class="icon-btn" (click)="editSubfolder(folder)"
                    *ngIf="(isHost == true || isHost == 'true') && isEditable">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 22H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                      <path
                        d="M13.8881 3.66293L14.6296 2.92142C15.8581 1.69286 17.85 1.69286 19.0786 2.92142C20.3071 4.14999 20.3071 6.14188 19.0786 7.37044L18.3371 8.11195M13.8881 3.66293C13.8881 3.66293 13.9807 5.23862 15.3711 6.62894C16.7614 8.01926 18.3371 8.11195 18.3371 8.11195M13.8881 3.66293L7.07106 10.4799C6.60933 10.9416 6.37846 11.1725 6.17992 11.4271C5.94571 11.7273 5.74491 12.0522 5.58107 12.396C5.44219 12.6874 5.33894 12.9972 5.13245 13.6167L4.25745 16.2417M18.3371 8.11195L11.5201 14.9289C11.0584 15.3907 10.8275 15.6215 10.5729 15.8201C10.2727 16.0543 9.94775 16.2551 9.60398 16.4189C9.31256 16.5578 9.00282 16.6611 8.38334 16.8675L5.75834 17.7426M5.75834 17.7426L5.11667 17.9564C4.81182 18.0581 4.47573 17.9787 4.2485 17.7515C4.02128 17.5243 3.94194 17.1882 4.04356 16.8833L4.25745 16.2417M5.75834 17.7426L4.25745 16.2417"
                        stroke="currentColor" stroke-width="1.5" />
                    </svg>
                  </button>
                  <button *ngIf="(isHost == true || isHost == 'true') && isEditable" class="icon-btn"
                    (click)="removeSubfolder(folder, $event)">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20.5001 6H3.5" stroke="#131A26" stroke-width="1.5" stroke-linecap="round" />
                      <path
                        d="M18.8332 8.5L18.3732 15.3991C18.1962 18.054 18.1077 19.3815 17.2427 20.1907C16.3777 21 15.0473 21 12.3865 21H11.6132C8.95235 21 7.62195 21 6.75694 20.1907C5.89194 19.3815 5.80344 18.054 5.62644 15.3991L5.1665 8.5"
                        stroke="#131A26" stroke-width="1.5" stroke-linecap="round" />
                      <path d="M9.5 11L10 16" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" />
                      <path d="M14.5 11L14 16" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" />
                      <path
                        d="M6.5 6C6.55588 6 6.58382 6 6.60915 5.99936C7.43259 5.97849 8.15902 5.45491 8.43922 4.68032C8.44784 4.65649 8.45667 4.62999 8.47434 4.57697L8.57143 4.28571C8.65431 4.03708 8.69575 3.91276 8.75071 3.8072C8.97001 3.38607 9.37574 3.09364 9.84461 3.01877C9.96213 3 10.0932 3 10.3553 3H13.6447C13.9068 3 14.0379 3 14.1554 3.01877C14.6243 3.09364 15.03 3.38607 15.2493 3.8072C15.3043 3.91276 15.3457 4.03708 15.4286 4.28571L15.5257 4.57697C15.5433 4.62992 15.5522 4.65651 15.5608 4.68032C15.841 5.45491 16.5674 5.97849 17.3909 5.99936C17.4162 6 17.4441 6 17.5 6"
                        stroke="#1C274C" stroke-width="1.5" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="form-actions fixed-button" *ngIf="isEditable">
            <button type="button" class="cancel-btn" (click)="cancel()">Cancel</button>
            <button type="submit" class="save-btn" [disabled]="currentSection === sections.length - 1"
              (click)="incrementSection()">Save</button>
          </div>
        </form>
      </div>
      <div *ngSwitchCase="2" class="section-content" style="width: 600px;
    margin: 0 auto;"> <!-- Section 3 -->
        <!-- <section class="guest-section" *ngIf="access !== 'restricted'"> -->
        <section class="guest-section">
          <!-- <app-storage-upgrade-banner style="display:block;margin-bottom:12px;"></app-storage-upgrade-banner> -->
          <div class="guest-header">
            <span class="invite-header">Invite Guests</span>
            <button *ngIf="isHost === true || isHost === 'true'" class="picaggo-btn-primary"
              (click)="inviteUsers()"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                fill="none">
                <circle cx="6.66667" cy="4.00065" r="2.66667" fill="white" />
                <path
                  d="M11.9999 11.666C11.9999 13.3229 11.9999 14.666 6.66659 14.666C1.33325 14.666 1.33325 13.3229 1.33325 11.666C1.33325 10.0092 3.72107 8.66602 6.66659 8.66602C9.6121 8.66602 11.9999 10.0092 11.9999 11.666Z"
                  fill="white" />
                <path
                  d="M13.9999 6.66733H12.6666M12.6666 6.66733H11.3333M12.6666 6.66733L12.6666 5.33398M12.6666 6.66733L12.6666 8.00065"
                  stroke="white" stroke-linecap="round" />
              </svg> Invite</button>
          </div>
          <div class="filter-buttons" *ngIf="collaborators?.length > 0">
            <button [ngClass]="{ 'active': selectedFilter === 'all' }" (click)="filterGuests('all')">All ({{ allCount
              }})</button>
            <button [ngClass]="{ 'active': selectedFilter === 'yes' }" (click)="filterGuests('yes')">Yes ({{ yesCount
              }})</button>
            <button [ngClass]="{ 'active': selectedFilter === 'no' }" (click)="filterGuests('no')">No ({{ noCount
              }})</button>
            <button [ngClass]="{ 'active': selectedFilter === 'maybe' }" (click)="filterGuests('maybe')">Maybe ({{
              maybeCount }})</button>
          </div>
          <div style="display: flex;justify-content: center;">
            <span *ngIf="isGuestLoading" class="loader" style="margin-top: 10%;"></span>
          </div>
          <div *ngIf="collaborators?.length > 0 && !isGuestLoading">
            <div class="guest-list">
              <div class="guest-card-wrapper" *ngFor="let guest of filteredGuests; let i = index"
                [class.pending-transfer]="hostTransferPendingUserId === guest.user_id?.toString()">
                <div class="guest-card">
                  <div class="collab-avatar" *ngIf="guest.imageUrl; else initials"
                    [ngStyle]="{ 'background': 'url(' + guest.imageUrl + ')  lightgray 50% / cover no-repeat' }">
                    <div class="collab_icon" *ngIf="guest.access_type == 'write'">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M5.33325 2.66667C5.33325 2.29848 5.60877 2 5.94864 2H10.0512C10.3911 2 10.6666 2.29848 10.6666 2.66667C10.6666 3.03486 10.3911 3.33333 10.0512 3.33333H5.94864C5.60877 3.33333 5.33325 3.03486 5.33325 2.66667Z"
                          fill="white" />
                        <path
                          d="M6.33336 9.00023C6.33336 8.11261 7.07955 7.39306 8.00003 7.39306C8.9205 7.39306 9.66669 8.11261 9.66669 9.00023C9.66669 9.88784 8.9205 10.6074 8.00003 10.6074C7.07955 10.6074 6.33336 9.88784 6.33336 9.00023Z"
                          fill="white" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M9.4814 14H6.51844C4.43775 14 3.39741 14 2.65008 13.5185C2.32655 13.31 2.04877 13.0422 1.8326 12.7302C1.33325 12.0095 1.33325 11.0063 1.33325 8.99992V8.99859C1.33325 6.99307 1.33325 5.99031 1.83249 5.26982C2.04866 4.95784 2.32644 4.68998 2.64997 4.48152C3.3973 4 4.43764 4 6.51833 4H9.48129C11.562 4 12.6023 4 13.3496 4.48152C13.6732 4.68998 13.951 4.95784 14.1671 5.26982C14.6665 5.99047 14.6666 6.99351 14.6666 8.99992C14.6666 11.0063 14.6666 12.0095 14.1672 12.7302C13.9511 13.0422 13.6733 13.31 13.3498 13.5185C12.6024 14 11.5621 14 9.4814 14ZM5.22225 9.00023C5.22225 7.52087 6.4659 6.32161 8.00003 6.32161C9.53415 6.32161 10.7778 7.52087 10.7778 9.00023C10.7778 10.4796 9.53415 11.6788 8.00003 11.6788C6.4659 11.6788 5.22225 10.4796 5.22225 9.00023ZM11.5185 6.85734C11.5185 6.56147 11.7673 6.32161 12.0741 6.32161H12.4445C12.7513 6.32161 13 6.56147 13 6.85734C13 7.15321 12.7513 7.39306 12.4445 7.39306H12.0741C11.7673 7.39306 11.5185 7.15321 11.5185 6.85734Z"
                          fill="white" />
                      </svg>
                    </div>
                    <div class="viewer_icon" *ngIf="guest.access_type == 'read'">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M6.49992 7.99935C6.49992 7.17092 7.17149 6.49935 7.99992 6.49935C8.82835 6.49935 9.49992 7.17092 9.49992 7.99935C9.49992 8.82778 8.82835 9.49935 7.99992 9.49935C7.17149 9.49935 6.49992 8.82778 6.49992 7.99935Z"
                          fill="white" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M1.33325 7.99935C1.33325 9.09227 1.61656 9.46033 2.18318 10.1965C3.31456 11.6663 5.21199 13.3327 7.99992 13.3327C10.7878 13.3327 12.6853 11.6663 13.8167 10.1965C14.3833 9.46033 14.6666 9.09227 14.6666 7.99935C14.6666 6.90643 14.3833 6.53837 13.8167 5.80224C12.6853 4.33239 10.7878 2.66602 7.99992 2.66602C5.21199 2.66602 3.31456 4.33239 2.18318 5.80224C1.61656 6.53837 1.33325 6.90643 1.33325 7.99935ZM7.99992 5.49935C6.61921 5.49935 5.49992 6.61864 5.49992 7.99935C5.49992 9.38006 6.61921 10.4993 7.99992 10.4993C9.38063 10.4993 10.4999 9.38006 10.4999 7.99935C10.4999 6.61864 9.38063 5.49935 7.99992 5.49935Z"
                          fill="white" />
                      </svg>
                    </div>
                    <!-- <img [src]="guest.imageUrl" [alt]="guest.name" /> -->
                  </div>
                  <ng-template #initials>
                    <div class="collab-avatar fallback">
                      {{ guest.name?.charAt(0)?.toUpperCase() }}

                      <div class="collab_icon2" *ngIf="guest.access_type == 'write'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M5.33325 2.66667C5.33325 2.29848 5.60877 2 5.94864 2H10.0512C10.3911 2 10.6666 2.29848 10.6666 2.66667C10.6666 3.03486 10.3911 3.33333 10.0512 3.33333H5.94864C5.60877 3.33333 5.33325 3.03486 5.33325 2.66667Z"
                            fill="white" />
                          <path
                            d="M6.33336 9.00023C6.33336 8.11261 7.07955 7.39306 8.00003 7.39306C8.9205 7.39306 9.66669 8.11261 9.66669 9.00023C9.66669 9.88784 8.9205 10.6074 8.00003 10.6074C7.07955 10.6074 6.33336 9.88784 6.33336 9.00023Z"
                            fill="white" />
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M9.4814 14H6.51844C4.43775 14 3.39741 14 2.65008 13.5185C2.32655 13.31 2.04877 13.0422 1.8326 12.7302C1.33325 12.0095 1.33325 11.0063 1.33325 8.99992V8.99859C1.33325 6.99307 1.33325 5.99031 1.83249 5.26982C2.04866 4.95784 2.32644 4.68998 2.64997 4.48152C3.3973 4 4.43764 4 6.51833 4H9.48129C11.562 4 12.6023 4 13.3496 4.48152C13.6732 4.68998 13.951 4.95784 14.1671 5.26982C14.6665 5.99047 14.6666 6.99351 14.6666 8.99992C14.6666 11.0063 14.6666 12.0095 14.1672 12.7302C13.9511 13.0422 13.6733 13.31 13.3498 13.5185C12.6024 14 11.5621 14 9.4814 14ZM5.22225 9.00023C5.22225 7.52087 6.4659 6.32161 8.00003 6.32161C9.53415 6.32161 10.7778 7.52087 10.7778 9.00023C10.7778 10.4796 9.53415 11.6788 8.00003 11.6788C6.4659 11.6788 5.22225 10.4796 5.22225 9.00023ZM11.5185 6.85734C11.5185 6.56147 11.7673 6.32161 12.0741 6.32161H12.4445C12.7513 6.32161 13 6.56147 13 6.85734C13 7.15321 12.7513 7.39306 12.4445 7.39306H12.0741C11.7673 7.39306 11.5185 7.15321 11.5185 6.85734Z"
                            fill="white" />
                        </svg>
                      </div>
                      <div class="viewer_icon2" *ngIf="guest.access_type == 'read'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path
                            d="M6.49992 7.99935C6.49992 7.17092 7.17149 6.49935 7.99992 6.49935C8.82835 6.49935 9.49992 7.17092 9.49992 7.99935C9.49992 8.82778 8.82835 9.49935 7.99992 9.49935C7.17149 9.49935 6.49992 8.82778 6.49992 7.99935Z"
                            fill="white" />
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M1.33325 7.99935C1.33325 9.09227 1.61656 9.46033 2.18318 10.1965C3.31456 11.6663 5.21199 13.3327 7.99992 13.3327C10.7878 13.3327 12.6853 11.6663 13.8167 10.1965C14.3833 9.46033 14.6666 9.09227 14.6666 7.99935C14.6666 6.90643 14.3833 6.53837 13.8167 5.80224C12.6853 4.33239 10.7878 2.66602 7.99992 2.66602C5.21199 2.66602 3.31456 4.33239 2.18318 5.80224C1.61656 6.53837 1.33325 6.90643 1.33325 7.99935ZM7.99992 5.49935C6.61921 5.49935 5.49992 6.61864 5.49992 7.99935C5.49992 9.38006 6.61921 10.4993 7.99992 10.4993C9.38063 10.4993 10.4999 9.38006 10.4999 7.99935C10.4999 6.61864 9.38063 5.49935 7.99992 5.49935Z"
                            fill="white" />
                        </svg>
                      </div>
                    </div>
                  </ng-template>
                  <div class="guest-info">
                    <span class="guest-name">{{ guest.name }}</span>
                    <p class="guest-subtext"> <span *ngIf="eventData?.rsvp == 1">{{ guest.guests }} Guests •
                      </span><span>{{
                        guest.totalFiles ? guest.totalFiles : 0 }} Photos</span></p>
                  </div>
                  <span class="status" [ngClass]="guest?.digitalRSVP?.toLowerCase()">{{ guest.digitalRSVP }}</span>

                  <div class="more-container" (clickOutside)="closeMenu()" *ngIf="isHost == true || isHost == 'true'">
                    <button class="more-btn" (click)="toggleMenu(i, $event)"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <circle cx="12" cy="5" r="2" transform="rotate(90 12 5)" stroke="#131A26" stroke-width="1.5"/>
  <circle cx="12" cy="12" r="2" transform="rotate(90 12 12)" stroke="#131A26" stroke-width="1.5"/>
  <circle cx="12" cy="19" r="2" transform="rotate(90 12 19)" stroke="#1C274C" stroke-width="1.5"/>
</svg></button>
                  </div>
                </div>
                <!-- Host transfer pending callout -->
                <div class="host-transfer-callout" *ngIf="hostTransferPendingUserId === guest.user_id?.toString()">
                  <span class="callout-text">Request to assign {{ guest.name }} as host has been sent. Waiting for confirmation.</span>
                  <button class="callout-cancel-btn"
                    (click)="cancelHostTransfer(guest.user_id.toString())">Cancel Request</button>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="collaborators?.length === 0 && !isGuestLoading"
            style="text-align: center; margin-top: 10%; font-size: large;color:darkgray">
            You have not invited anybody to this event yet!
          </div>

        </section>
      </div>

      <!-- Landing Page Section -->
      <div *ngSwitchCase="3" class="section-content" style="width:600px;margin: 0 auto;">
        <div class="header-2" style="float: left;">Landing Page</div>
        <div>
          <button *ngIf="!isEditable && (isHost === true || isHost === 'true')" (click)="toggleEdit()" type="button"
            class="picaggo-btn-primary" style="float: right;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.25 22C3.25 21.5858 3.58579 21.25 4 21.25H20C20.4142 21.25 20.75 21.5858 20.75 22C20.75 22.4142 20.4142 22.75 20 22.75H4C3.58579 22.75 3.25 22.4142 3.25 22Z"
                fill="white" />
              <path
                d="M11.5201 14.929L11.5201 14.9289L17.4368 9.01225C16.6315 8.6771 15.6777 8.12656 14.7757 7.22455C13.8736 6.32238 13.323 5.36846 12.9879 4.56312L7.07106 10.4799L7.07101 10.48C6.60932 10.9417 6.37846 11.1725 6.17992 11.4271C5.94571 11.7273 5.74491 12.0522 5.58107 12.396C5.44219 12.6874 5.33894 12.9972 5.13245 13.6167L4.04356 16.8833C3.94194 17.1882 4.02128 17.5243 4.2485 17.7515C4.47573 17.9787 4.81182 18.0581 5.11667 17.9564L8.38334 16.8676C9.00281 16.6611 9.31256 16.5578 9.60398 16.4189C9.94775 16.2551 10.2727 16.0543 10.5729 15.8201C10.8275 15.6215 11.0584 15.3907 11.5201 14.929Z"
                fill="white" />
              <path
                d="M19.0786 7.37044C20.3071 6.14188 20.3071 4.14999 19.0786 2.92142C17.85 1.69286 15.8581 1.69286 14.6296 2.92142L13.9199 3.63105C13.9296 3.6604 13.9397 3.69015 13.9502 3.72028C14.2103 4.47 14.701 5.45281 15.6243 6.37602C16.5475 7.29923 17.5303 7.78999 18.28 8.05009C18.31 8.0605 18.3396 8.07054 18.3688 8.08021L19.0786 7.37044Z"
                fill="white" />
            </svg>
            Edit
          </button>
        </div>
        <div class="event-content">
          <form [formGroup]="newEventForm">
            <div class="form-group">
              <!-- <label>Landing Page</label> -->
              <div class="radio-group">
                <label class="radio-option" [class.disabled]="!isEditable">
                  <input type="radio" formControlName="defaultTab" value="photos" [disabled]="!isEditable">
                  <span class="radio-label">
                    <!-- <span class="radio-icon">📷</span> -->
                    <span class="radio-text">Photos</span>
                  </span>
                </label>
                <label class="radio-option" [class.disabled]="!isEditable">
                  <input type="radio" formControlName="defaultTab" value="guestbook" [disabled]="!isEditable">
                  <span class="radio-label">
                    <!-- <span class="radio-icon">📝</span> -->
                    <span class="radio-text">Guestbook</span>
                  </span>
                </label>
              </div>
              <small class="hint">Select which tab guests will see first when they open the event</small>
            </div>
            <div class="action-buttons" *ngIf="isEditable">
              <button type="button" class="btn-cancel" (click)="cancelEdit()" [disabled]="isLoading">
                Cancel
              </button>
              <button type="button" class="btn-save picaggo-btn-primary" (click)="saveDefaultTab()"
                [disabled]="isLoading">
                <span>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M17 21V13H7V21" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M7 3V8H15" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  Save Changes
                </span>
                <!-- <span *ngIf="isLoading" class="loader"></span> -->
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Bulk Download Permission Section -->
      <div *ngSwitchCase="4" class="section-content" style="width:600px;margin: 0 auto;">
        <div class="header-2" style="float: left;">Bulk Download </div>
        <div>
          <button *ngIf="!isEditable && (isHost === true || isHost === 'true')" (click)="toggleEdit()" type="button"
            class="picaggo-btn-primary" style="float: right;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.25 22C3.25 21.5858 3.58579 21.25 4 21.25H20C20.4142 21.25 20.75 21.5858 20.75 22C20.75 22.4142 20.4142 22.75 20 22.75H4C3.58579 22.75 3.25 22.4142 3.25 22Z"
                fill="white" />
              <path
                d="M11.5201 14.929L11.5201 14.9289L17.4368 9.01225C16.6315 8.6771 15.6777 8.12656 14.7757 7.22455C13.8736 6.32238 13.323 5.36846 12.9879 4.56312L7.07106 10.4799L7.07101 10.48C6.60932 10.9417 6.37846 11.1725 6.17992 11.4271C5.94571 11.7273 5.74491 12.0522 5.58107 12.396C5.44219 12.6874 5.33894 12.9972 5.13245 13.6167L4.04356 16.8833C3.94194 17.1882 4.02128 17.5243 4.2485 17.7515C4.47573 17.9787 4.81182 18.0581 5.11667 17.9564L8.38334 16.8676C9.00281 16.6611 9.31256 16.5578 9.60398 16.4189C9.94775 16.2551 10.2727 16.0543 10.5729 15.8201C10.8275 15.6215 11.0584 15.3907 11.5201 14.929Z"
                fill="white" />
              <path
                d="M19.0786 7.37044C20.3071 6.14188 20.3071 4.14999 19.0786 2.92142C17.85 1.69286 15.8581 1.69286 14.6296 2.92142L13.9199 3.63105C13.9296 3.6604 13.9397 3.69015 13.9502 3.72028C14.2103 4.47 14.701 5.45281 15.6243 6.37602C16.5475 7.29923 17.5303 7.78999 18.28 8.05009C18.31 8.0605 18.3396 8.07054 18.3688 8.08021L19.0786 7.37044Z"
                fill="white" />
            </svg>
            Edit
          </button>
        </div>
        <div class="event-content">
          <form [formGroup]="newEventForm">
            <div class="form-group">
              <div class="radio-group">
                <label class="radio-option" [class.disabled]="!isEditable">
                  <input type="radio" formControlName="allowBulkDownload" [value]="true" [disabled]="!isEditable">
                  <span class="radio-label">
                    <span class="radio-text">Allow participants to bulk download</span>
                  </span>
                </label>
                <label class="radio-option" [class.disabled]="!isEditable">
                  <input type="radio" formControlName="allowBulkDownload" [value]="false" [disabled]="!isEditable">
                  <span class="radio-label">
                    <span class="radio-text">Only host can bulk download</span>
                  </span>
                </label>
              </div>
              <small class="hint">Control whether event participants can download all photos at once</small>
            </div>
            <div class="action-buttons" *ngIf="isEditable">
              <button type="button" class="btn-cancel" (click)="cancelEdit()" [disabled]="isLoading">
                Cancel
              </button>
              <button type="button" class="btn-save picaggo-btn-primary" (click)="saveBulkDownloadSetting()"
                [disabled]="isLoading">
                <span>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M17 21V13H7V21" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M7 3V8H15" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  Save Changes
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Sorting Order Section -->
      <div *ngSwitchCase="7" class="section-content" style="width:600px;margin: 0 auto;">
        <div class="header-2" style="float: left;">Sorting Order</div>
        <div>
          <button *ngIf="!isEditable && (isHost === true || isHost === 'true')" (click)="toggleEdit()" type="button"
            class="picaggo-btn-primary" style="float: right;">
            Edit
          </button>
        </div>
        <div style="clear: both;"></div>
        <div class="event-content">
          <form [formGroup]="newEventForm">
            <div class="form-group">
              <div class="radio-group">
                <label class="radio-option" [class.disabled]="!isEditable">
                  <input type="radio" formControlName="sortOrder" value="desc" [disabled]="!isEditable">
                  <span class="radio-label">
                    <span class="radio-text">Latest First</span>
                  </span>
                </label>
                <label class="radio-option" [class.disabled]="!isEditable">
                  <input type="radio" formControlName="sortOrder" value="asc" [disabled]="!isEditable">
                  <span class="radio-label">
                    <span class="radio-text">Oldest First</span>
                  </span>
                </label>
              </div>
              <small class="hint">Choose the default order photos appear in for everyone viewing the gallery</small>
            </div>
            <div class="action-buttons" *ngIf="isEditable">
              <button type="button" class="btn-cancel" (click)="cancelEdit()" [disabled]="isLoading">
                Cancel
              </button>
              <button type="button" class="btn-save picaggo-btn-primary" (click)="saveSortOrder()"
                [disabled]="isLoading">
                <span>Save Changes</span>
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Guest Uploads Section -->
      <div *ngSwitchCase="8" class="section-content" style="width:600px;margin: 0 auto;">
        <div class="header-2" style="float: left;">Guest Uploads</div>
        <div style="clear: both;"></div>
        <div class="event-content">
          <div class="form-group">
            <div style="display:flex; align-items:center; justify-content:space-between;">
              <span class="radio-text">{{ allowGuestUploads ? 'Guests can view & upload' : 'Guests can only view' }}</span>
              <label class="switch">
                <input type="checkbox" [(ngModel)]="allowGuestUploads" [ngModelOptions]="{ standalone: true }">
                <span class="slider round"></span>
              </label>
            </div>
            <small class="hint">{{ guestUploadsHint }}</small>
          </div>
          <div class="form-group" *ngIf="guestUploadsQrImage">
            <img [src]="guestUploadsQrImage" alt="Guest access QR Code" style="max-width: 220px; display: block;" />
          </div>
          <div class="form-group" *ngIf="guestUploadsLink" style="display:flex; align-items:center; gap:8px;">
            <span style="flex:1; word-break: break-all; font-size: 13px;">{{ guestUploadsLink }}</span>
            <button type="button" class="btn-cancel" (click)="copyGuestUploadsLink()">{{ guestUploadsLinkCopied ? 'Copied!' : 'Copy' }}</button>
          </div>
        </div>
      </div>

      <!-- Branding Section -->
      <div *ngSwitchCase="5" class="section-content" style="width:600px;margin: 0 auto;">
        <!-- Branding Toggle - Desktop Only, Host Only -->
        <div class="branding-toggle-header mobile-hide"
          *ngIf="!isBrandingLoading && (isHost === true || isHost === 'true')" [formGroup]="brandingForm">
          <div class="toggle-container-header">
            <label class="toggle-label">Show Branding on Gallery</label>
            <label class="switch1">
              <input type="checkbox" formControlName="isActive" [disabled]="!isEditable" (change)="onToggleChange()">
              <span class="slider round"></span>
            </label>
          </div>
          <small class="hint">Enable to display your branding information on the event gallery page</small>
        </div>

        <div class="header-2" style="float: left;" *ngIf="brandingForm.get('isActive')?.value">Event Branding</div>
        <div>
          <button *ngIf="!isEditable && (isHost === true || isHost === 'true') && brandingForm.get('isActive')?.value"
            (click)="toggleEdit()" type="button" class="picaggo-btn-primary" style="float: right;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.25 22C3.25 21.5858 3.58579 21.25 4 21.25H20C20.4142 21.25 20.75 21.5858 20.75 22C20.75 22.4142 20.4142 22.75 20 22.75H4C3.58579 22.75 3.25 22.4142 3.25 22Z"
                fill="white" />
              <path
                d="M11.5201 14.929L11.5201 14.9289L17.4368 9.01225C16.6315 8.6771 15.6777 8.12656 14.7757 7.22455C13.8736 6.32238 13.323 5.36846 12.9879 4.56312L7.07106 10.4799L7.07101 10.48C6.60932 10.9417 6.37846 11.1725 6.17992 11.4271C5.94571 11.7273 5.74491 12.0522 5.58107 12.396C5.44219 12.6874 5.33894 12.9972 5.13245 13.6167L4.04356 16.8833C3.94194 17.1882 4.02128 17.5243 4.2485 17.7515C4.47573 17.9787 4.81182 18.0581 5.11667 17.9564L8.38334 16.8676C9.00281 16.6611 9.31256 16.5578 9.60398 16.4189C9.94775 16.2551 10.2727 16.0543 10.5729 15.8201C10.8275 15.6215 11.0584 15.3907 11.5201 14.929Z"
                fill="white" />
              <path
                d="M19.0786 7.37044C20.3071 6.14188 20.3071 4.14999 19.0786 2.92142C17.85 1.69286 15.8581 1.69286 14.6296 2.92142L13.9199 3.63105C13.9296 3.6604 13.9397 3.69015 13.9502 3.72028C14.2103 4.47 14.701 5.45281 15.6243 6.37602C16.5475 7.29923 17.5303 7.78999 18.28 8.05009C18.31 8.0605 18.3396 8.07054 18.3688 8.08021L19.0786 7.37044Z"
                fill="white" />
            </svg>
          </button>
        </div>

        <!-- Loading State -->
        <div *ngIf="isBrandingLoading" class="loading-overlay">
          <span class="loader"></span>
        </div>

        <!-- Branding Form Content -->
        <div class="event-content" *ngIf="!isBrandingLoading">
          <form [formGroup]="brandingForm" (ngSubmit)="saveBranding()" *ngIf="brandingForm.get('isActive')?.value">

            <!-- Brand Name -->
            <div class="form-group">
              <label>Brand Name <span class="required">*</span></label>
              <input matInput formControlName="brandName" type="text" placeholder="Enter brand name" maxlength="100"
                [readonly]="!isEditable" required />
              <mat-hint align="end" class="char-count">
                {{ brandingForm.get('brandName')?.value?.length || 0 }}/100 characters
              </mat-hint>
              <div *ngIf="brandingForm.get('brandName')?.touched && brandingForm.get('brandName')?.invalid"
                class="alert alert-danger">
                <p *ngIf="brandingForm.get('brandName')?.errors?.['required']">Brand Name is required.</p>
                <p *ngIf="brandingForm.get('brandName')?.errors?.['maxlength']">Brand Name cannot exceed 100 characters.
                </p>
              </div>
            </div>

            <!-- Logo Upload -->
            <div class="form-group">
              <label>Brand Logo</label>
              <div class="logo-upload-section">
                <input type="file" id="logoInput" accept="image/*" [disabled]="!isEditable"
                  (change)="onLogoSelected($event)" style="display: none;" />
                <button type="button" class="upload-btn" [disabled]="!isEditable" (click)="triggerFileInput()">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M17 8L12 3L7 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M12 3V15" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  {{ logoUrl ? 'Change Logo' : 'Upload Logo' }}
                </button>

                <div class="logo-preview" *ngIf="logoUrl">
                  <img [src]="logoUrl" alt="Brand Logo">
                  <button type="button" class="remove-logo" [disabled]="!isEditable" (click)="removeLogo()">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </button>
                </div>
              </div>
              <small class="hint">Recommended size: 500x500px, Max: 2MB</small>
            </div>

            <!-- Facebook Link -->
            <div class="form-group">
              <label>Facebook Page</label>
              <input matInput formControlName="facebookLink" type="url" placeholder="https://facebook.com/yourpage"
                [readonly]="!isEditable" />
              <div *ngIf="brandingForm.get('facebookLink')?.touched && brandingForm.get('facebookLink')?.invalid"
                class="alert alert-danger">
                <p>Please enter a valid Facebook URL.</p>
              </div>
            </div>

            <!-- Instagram Link -->
            <div class="form-group">
              <label>Instagram Profile</label>
              <input matInput formControlName="instagramLink" type="url" placeholder="https://instagram.com/yourprofile"
                [readonly]="!isEditable" />
              <div *ngIf="brandingForm.get('instagramLink')?.touched && brandingForm.get('instagramLink')?.invalid"
                class="alert alert-danger">
                <p>Please enter a valid Instagram URL.</p>
              </div>
            </div>

            <!-- Website Link -->
            <div class="form-group">
              <label>Website</label>
              <input matInput formControlName="websiteLink" type="url" placeholder="https://www.yourwebsite.com"
                [readonly]="!isEditable" />
              <div *ngIf="brandingForm.get('websiteLink')?.touched && brandingForm.get('websiteLink')?.invalid"
                class="alert alert-danger">
                <p>Please enter a valid website URL.</p>
              </div>
            </div>

            <!-- Phone Number -->
            <div class="form-group">
              <label>Contact Phone</label>
              <input matInput formControlName="phoneNumber" type="tel" placeholder="+1 (555) 123-4567"
                [readonly]="!isEditable" />
              <div *ngIf="brandingForm.get('phoneNumber')?.touched && brandingForm.get('phoneNumber')?.invalid"
                class="alert alert-danger">
                <p>Please enter a valid phone number.</p>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="action-buttons" *ngIf="isEditable">
              <button type="button" class="btn-cancel" (click)="cancelBrandingEdit()" [disabled]="isLoading">
                Cancel
              </button>
              <button type="submit" class="btn-save picaggo-btn-primary" [disabled]="isLoading || brandingForm.invalid">
                <span *ngIf="!isLoading">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M17 21V13H7V21" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M7 3V8H15" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  Save Changes
                </span>

              </button>
            </div>
          </form>
        </div>
      </div> <!-- Popup Modal -->

      <!-- Canva Templates Section -->
      <div *ngSwitchCase="6" class="section-content canva-templates-section" style="width:600px;margin: 0 auto;">
        <ng-container *ngTemplateOutlet="canvaTemplatesContent"></ng-container>
      </div>

      <div class="popup-overlay" *ngIf="isFolderDialogOpen">
        <div class="popup">
          <h2 style="float: left;position: relative;
left: 21%;">{{ popupTitle }}</h2>
          <button style="float: right;position: relative;top:-7px;right: -5px;" class="btn"
            (click)="closeFolderDialog()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.0008 13.3998L7.10078 18.2998C6.91745 18.4831 6.68411 18.5748 6.40078 18.5748C6.11745 18.5748 5.88411 18.4831 5.70078 18.2998C5.51745 18.1165 5.42578 17.8831 5.42578 17.5998C5.42578 17.3165 5.51745 17.0831 5.70078 16.8998L10.6008 11.9998L5.70078 7.0998C5.51745 6.91647 5.42578 6.68314 5.42578 6.3998C5.42578 6.11647 5.51745 5.88314 5.70078 5.6998C5.88411 5.51647 6.11745 5.4248 6.40078 5.4248C6.68411 5.4248 6.91745 5.51647 7.10078 5.6998L12.0008 10.5998L16.9008 5.6998C17.0841 5.51647 17.3174 5.4248 17.6008 5.4248C17.8841 5.4248 18.1174 5.51647 18.3008 5.6998C18.4841 5.88314 18.5758 6.11647 18.5758 6.3998C18.5758 6.68314 18.4841 6.91647 18.3008 7.0998L13.4008 11.9998L18.3008 16.8998C18.4841 17.0831 18.5758 17.3165 18.5758 17.5998C18.5758 17.8831 18.4841 18.1165 18.3008 18.2998C18.1174 18.4831 17.8841 18.5748 17.6008 18.5748C17.3174 18.5748 17.0841 18.4831 16.9008 18.2998L12.0008 13.3998Z"
                fill="currentColor" />
            </svg></button>
          <input [(ngModel)]="newFolderName" placeholder="Enter album Name" class="input-field" />
          <div class="popup-actions">

            <button (click)="addSubfolder()" class="save-btn">Save</button>
          </div>
        </div>
      </div>
    </ng-container>

  </div>
</div>

<ng-template [ngIf]="isCreating || isLoading || isGuestLoading">
  <div class="overlay1">
    <span class="loader"></span>
  </div>
</ng-template>

<!-- Global more-menu portal: rendered outside all fixed/scrollable containers so it's never clipped on iOS -->
<div class="more-menu-portal" *ngIf="openMenuIndex !== null" [style.top.px]="menuPosition.top"
  [style.right.px]="menuPosition.right">

 <button (click)="changeHost(selectedMenuGuest?.user_id, selectedMenuGuest)">Assign as Host <span
      style="float:right;padding-left:10px"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM7 14.75L15 14.75L13.0693 16.4349C12.7573 16.7073 12.7251 17.1811 12.9974 17.4931C13.2698 17.8052 13.7436 17.8374 14.0557 17.5651L17.4932 14.5651C17.7287 14.3595 17.812 14.0294 17.7022 13.7367C17.5925 13.4439 17.3126 13.25 17 13.25L7 13.25C6.58579 13.25 6.25 13.5858 6.25 14C6.25 14.4142 6.58579 14.75 7 14.75ZM11.0026 6.50685C11.2749 6.81893 11.2427 7.29271 10.9307 7.56507L9 9.25H17C17.4142 9.25 17.75 9.58579 17.75 10C17.75 10.4142 17.4142 10.75 17 10.75H7C6.68737 10.75 6.40753 10.5561 6.29775 10.2633C6.18798 9.97061 6.2713 9.6405 6.50685 9.43493L9.94435 6.43493C10.2564 6.16257 10.7302 6.19477 11.0026 6.50685Z"
          fill="#260808" />
      </svg></span>
  </button> 
  <button style="color:#B22424" (click)="removeUser(selectedMenuGuest?.user_id)">Remove User <span
      style="float:right;padding-left:10px"><svg width="18" height="20" viewBox="0 0 18 20" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 4.38597C0 3.90152 0.34538 3.50879 0.771428 3.50879L3.43567 3.50832C3.96502 3.49306 4.43202 3.11033 4.61214 2.54412C4.61688 2.52923 4.62232 2.51087 4.64185 2.44424L4.75665 2.05256C4.8269 1.81241 4.8881 1.60318 4.97375 1.41617C5.31209 0.677359 5.93808 0.164319 6.66147 0.032968C6.84457 -0.0002799 7.03848 -0.000139292 7.26106 2.21617e-05H10.7391C10.9617 -0.000139292 11.1556 -0.0002799 11.3387 0.032968C12.0621 0.164319 12.6881 0.677359 13.0264 1.41617C13.1121 1.60318 13.1733 1.81241 13.2435 2.05256L13.3583 2.44424C13.3778 2.51087 13.3833 2.52923 13.388 2.54412C13.5682 3.11033 14.1278 3.49353 14.6571 3.50879H17.2286C17.6546 3.50879 18 3.90152 18 4.38597C18 4.87043 17.6546 5.26316 17.2286 5.26316H0.771428C0.34538 5.26316 0 4.87043 0 4.38597Z"
          fill="#B32424" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M8.5956 20H9.4044C12.1871 20 13.5785 20 14.4831 19.1141C15.3878 18.2281 15.4803 16.7749 15.6654 13.8685L15.9321 9.6806C16.0326 8.10361 16.0828 7.31511 15.6289 6.81545C15.1751 6.31579 14.4087 6.31579 12.876 6.31579H5.12404C3.59127 6.31579 2.82488 6.31579 2.37105 6.81545C1.91722 7.31511 1.96744 8.10361 2.06788 9.6806L2.33459 13.8685C2.5197 16.7749 2.61225 18.2281 3.51689 19.1141C4.42153 20 5.81289 20 8.5956 20ZM12.2463 10.3456C12.2875 9.91174 11.9868 9.52486 11.5746 9.48148C11.1625 9.43809 10.7949 9.75463 10.7537 10.1885L10.2537 15.4516C10.2125 15.8855 10.5132 16.2724 10.9254 16.3157C11.3375 16.3591 11.7051 16.0426 11.7463 15.6087L12.2463 10.3456ZM6.42537 9.48148C6.83753 9.43809 7.20506 9.75463 7.24628 10.1885L7.74628 15.4516C7.78749 15.8855 7.48678 16.2724 7.07463 16.3157C6.66247 16.3591 6.29494 16.0426 6.25372 15.6087L5.75372 10.3456C5.71251 9.91174 6.01321 9.52486 6.42537 9.48148Z"
          fill="#B32424" />
      </svg></span>

  </button>
</div>

<!-- Shared Canva Templates content template (used by both desktop ngSwitchCase and mobile fullpage overlay) -->
<ng-template #canvaTemplatesContent>
  <div class="ct-header">
    <h2 class="ct-title">Templates</h2>
    <p class="ct-subtitle">Pick an invitation template and personalise it in Canva</p>
  </div>

  <!-- Event Details Clipboard Strip -->
  <div class="ct-details-strip" *ngIf="inviteData?.name || inviteData?.start_time || inviteData?.event_location || inviteData?.host_name || inviteData?.message">
    <div class="ct-details-label">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0">
        <path d="M9 12H15M9 16H13M17 3H7C5.9 3 5 3.9 5 5V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V5C19 3.9 18.1 3 17 3Z" stroke="#ee4147" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
      <span>Copy your event details to paste into Canva</span>
    </div>
    <div class="ct-details-fields">
      <span class="ct-detail-chip" *ngIf="inviteData?.name">
        <strong>Event:</strong> {{ inviteData.name }}
      </span>
      <span class="ct-detail-chip" *ngIf="inviteData?.event_location">
        <strong>Location:</strong> {{ inviteData.event_location }}
      </span>
      <span class="ct-detail-chip" *ngIf="inviteData?.host_name">
        <strong>Host:</strong> {{ inviteData.host_name }}
      </span>
      <span class="ct-detail-chip" *ngIf="inviteData?.start_time">
        <strong>Date:</strong> {{ inviteData.start_time | date:'mediumDate' }}
      </span>
    </div>
    <button class="ct-copy-btn" (click)="copyEventDetails()" [class.copied]="eventDetailsCopied">
      <svg *ngIf="!eventDetailsCopied" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" stroke-width="1.5"/>
        <path d="M5 15H4C2.9 15 2 14.1 2 13V4C2 2.9 2.9 2 4 2H13C14.1 2 15 2.9 15 4V5" stroke="currentColor" stroke-width="1.5"/>
      </svg>
      <svg *ngIf="eventDetailsCopied" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 13L9 17L19 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      {{ eventDetailsCopied ? 'Copied!' : 'Copy event details' }}
    </button>
  </div>

  <!-- Category Filter Tabs -->
  <div class="ct-tabs">
    <button class="ct-tab" [class.active]="selectedTemplateCategory === 'all'" (click)="filterTemplates('all')">All</button>
    <button class="ct-tab" [class.active]="selectedTemplateCategory === 'wedding'" (click)="filterTemplates('wedding')">
      Wedding
    </button>
    <button class="ct-tab" [class.active]="selectedTemplateCategory === 'birthday'" (click)="filterTemplates('birthday')">
      Birthday
    </button>
  </div>

  <!-- Template Grid -->
  <div *ngIf="isTemplatesLoading" class="ct-loading">
    <span class="loader"></span>
    <p>Loading templates…</p>
  </div>

  <div class="ct-grid" *ngIf="!isTemplatesLoading">
    <div class="ct-card" *ngFor="let template of filteredTemplates" (click)="openCanvaTemplate(template.canvaUrl)"
      role="button" tabindex="0" (keyup.enter)="openCanvaTemplate(template.canvaUrl)">
      <div class="ct-card-img-wrap">
        <img [src]="template.previewImage" [alt]="template.title" class="ct-card-img"
          onerror="this.src='assets/images/default_cover.png'" />
      </div>
      <div class="ct-card-body">
        <p class="ct-card-title">{{ template.title }}</p>
      </div>
    </div>
  </div>
</ng-template>